export const translated = (t: any) => ({
    gender: [{
        'label': t('gender.option.female'),
        'value': 'female'
    }, {
        'label': t('gender.option.male'),
        'value': 'male'
    },],
    occupationList: [
        {
            value: 'Govt. Employee',
            label: t('occupation.option.1'),
        },
        {
            value: 'Private Sector Employee',
            label: t('occupation.option.2'),
        },
        {
            value: 'Retired',
            label: t('occupation.option.3'),
        },
        {
            value: 'Businessman',
            label: t('occupation.option.4'),
        },
        {
            value: 'Self-Employed',
            label: t('occupation.option.5'),
        },
        {
            value: 'Farmer',
            label: t('occupation.option.6'),
        },
        {
            value: 'Goldsmith',
            label: t('occupation.option.7'),
        },
        {
            value: "Other",
            label: t('occupation.option.8'),
        },
    ],
})
export const data = {
    districtList: [
        {
            "value": "[ 01 ] BANKURA",
            "label": "BANKURA"
        },
        {
            "value": "[ 02 ] PURBA BARDHAMAN",
            "label": "PURBA BARDHAMAN"
        },
        {
            "value": "[ 03 ] BIRBHUM",
            "label": "BIRBHUM"
        },
        {
            "value": "[ 04 ] DARJEELING",
            "label": "DARJEELING"
        },
        {
            "value": "[ 05 ] HAORA",
            "label": "HAORA"
        },
        {
            "value": "[ 06 ] HUGLI",
            "label": "HUGLI"
        },
        {
            "value": "[ 07 ] JALPAIGURI",
            "label": "JALPAIGURI"
        },
        {
            "value": "[ 08 ] COOCHBIHAR",
            "label": "COOCHBIHAR"
        },
        {
            "value": "[ 09 ] MALDA",
            "label": "MALDA"
        },
        {
            "value": "[ 10 ] PASCHIM MEDINIPUR",
            "label": "PASCHIM MEDINIPUR"
        },
        {
            "value": "[ 11 ] PURBA MEDINIPUR",
            "label": "PURBA MEDINIPUR"
        },
        {
            "value": "[ 12 ] MURSHIDABAD",
            "label": "MURSHIDABAD"
        },
        {
            "value": "[ 13 ] NADIA",
            "label": "NADIA"
        },
        {
            "value": "[ 14 ] PURULIA",
            "label": "PURULIA"
        },
        {
            "value": "[ 15 ] UTTAR 24 PARGANA",
            "label": "UTTAR 24 PARGANA"
        },
        {
            "value": "[ 16 ] DAKSHIN 24 PARGANA",
            "label": "DAKSHIN 24 PARGANA"
        },
        {
            "value": "[ 17 ] DAKSHIN DINAJPUR",
            "label": "DAKSHIN DINAJPUR"
        },
        {
            "value": "[ 18 ] UTTAR DINAJPUR",
            "label": "UTTAR DINAJPUR"
        },
        {
            "value": "[ 19 ] Kolkata",
            "label": "Kolkata"
        },
        {
            "value": "[ 20 ] ALIPURDUAR",
            "label": "ALIPURDUAR"
        },
        {
            "value": "[ 21 ] KALIMPONG",
            "label": "KALIMPONG"
        },
        {
            "value": "[ 22 ] JHARGRAM",
            "label": "JHARGRAM"
        },
        {
            "value": "[ 23 ] PASCHIM BARDHAMAN",
            "label": "PASCHIM BARDHAMAN"
        }
    ],
    blocks: [
        {
            district: "[ 01 ] BANKURA",
            blockList: [
                {
                    "value": "[ 01 ] BANKURA - I",
                    "label": "BANKURA - I"
                },
                {
                    "value": "[ 02 ] BANKURA - II",
                    "label": "BANKURA - II"
                },
                {
                    "value": "[ 03 ] CHATNA",
                    "label": "CHATNA"
                },
                {
                    "value": "[ 04 ] SALTORA",
                    "label": "SALTORA"
                },
                {
                    "value": "[ 05 ] MEJHIA",
                    "label": "MEJHIA"
                },
                {
                    "value": "[ 06 ] GANGAJALGHATI",
                    "label": "GANGAJALGHATI"
                },
                {
                    "value": "[ 07 ] BARJORA",
                    "label": "BARJORA"
                },
                {
                    "value": "[ 08 ] ONDA",
                    "label": "ONDA"
                },
                {
                    "value": "[ 09 ] TALDANGRA",
                    "label": "TALDANGRA"
                },
                {
                    "value": "[ 10 ] SIMLAPAL",
                    "label": "SIMLAPAL"
                },
                {
                    "value": "[ 11 ] KHATRA",
                    "label": "KHATRA"
                },
                {
                    "value": "[ 12 ] HIRBANDH",
                    "label": "HIRBANDH"
                },
                {
                    "value": "[ 13 ] INDPUR",
                    "label": "INDPUR"
                },
                {
                    "value": "[ 14 ] RAIPUR - I",
                    "label": "RAIPUR - I"
                },
                {
                    "value": "[ 15 ] RAIPUR - II",
                    "label": "RAIPUR - II"
                },
                {
                    "value": "[ 16 ] RANIBANDH",
                    "label": "RANIBANDH"
                },
                {
                    "value": "[ 17 ] BISHNUPUR",
                    "label": "BISHNUPUR"
                },
                {
                    "value": "[ 18 ] JOYPUR",
                    "label": "JOYPUR"
                },
                {
                    "value": "[ 19 ] KOTOLPUR",
                    "label": "KOTOLPUR"
                },
                {
                    "value": "[ 20 ] SONAMUKHI",
                    "label": "SONAMUKHI"
                },
                {
                    "value": "[ 21 ] PATRASHYAR",
                    "label": "PATRASHYAR"
                },
                {
                    "value": "[ 22 ] INDUS",
                    "label": "INDUS"
                }
            ]
        },
        {
            district: "[ 02 ] PURBA BARDHAMAN",
            blockList: [
                {
                    "value": "[ 01 ] BARDHAMAN-1",
                    "label": "BARDHAMAN-1"
                },
                {
                    "value": "[ 02 ] MEMARI-I",
                    "label": "MEMARI-I"
                },
                {
                    "value": "[ 03 ] MEMARI-II",
                    "label": "MEMARI-II"
                },
                {
                    "value": "[ 04 ] JAMALPUR",
                    "label": "JAMALPUR"
                },
                {
                    "value": "[ 05 ] RAINA-I",
                    "label": "RAINA-I"
                },
                {
                    "value": "[ 06 ] RAINA-2",
                    "label": "RAINA-2"
                },
                {
                    "value": "[ 07 ] KHANDOGHOSH",
                    "label": "KHANDOGHOSH"
                },
                {
                    "value": "[ 08 ] BHATAR",
                    "label": "BHATAR"
                },
                {
                    "value": "[ 09 ] AUSHGRAM-I",
                    "label": "AUSHGRAM-I"
                },
                {
                    "value": "[ 10 ] AUSHGRAM-II",
                    "label": "AUSHGRAM-II"
                },
                {
                    "value": "[ 11 ] GOLSI-II",
                    "label": "GOLSI-II"
                },
                {
                    "value": "[ 12 ] GOLSI-I",
                    "label": "GOLSI-I"
                },
                {
                    "value": "[ 18 ] BARDHAMAN-II",
                    "label": "BARDHAMAN-II"
                },
                {
                    "value": "[ 24 ] KATOA-I",
                    "label": "KATOA-I"
                },
                {
                    "value": "[ 25 ] KATOA-II",
                    "label": "KATOA-II"
                },
                {
                    "value": "[ 26 ] KETUGRAM-1",
                    "label": "KETUGRAM-1"
                },
                {
                    "value": "[ 27 ] KETUGRAM-II",
                    "label": "KETUGRAM-II"
                },
                {
                    "value": "[ 28 ] MONGALKOT",
                    "label": "MONGALKOT"
                },
                {
                    "value": "[ 29 ] KALNA-I",
                    "label": "KALNA-I"
                },
                {
                    "value": "[ 30 ] KALNA-II",
                    "label": "KALNA-II"
                },
                {
                    "value": "[ 31 ] PURBASHALI-I",
                    "label": "PURBASHALI-I"
                },
                {
                    "value": "[ 32 ] PURBASHALI-II",
                    "label": "PURBASHALI-II"
                },
                {
                    "value": "[ 33 ] MANTESWAR",
                    "label": "MANTESWAR"
                }
            ]
        }, {
            district: "[ 03 ] BIRBHUM",
            blockList: [
                {
                    "value": "[ 01 ] NALHATI - I",
                    "label": "NALHATI - I"
                },
                {
                    "value": "[ 02 ] NALHATI - II",
                    "label": "NALHATI - II"
                },
                {
                    "value": "[ 03 ] MURARI - I",
                    "label": "MURARI - I"
                },
                {
                    "value": "[ 04 ] MURARI - II",
                    "label": "MURARI - II"
                },
                {
                    "value": "[ 05 ] MAYURESWAR - I",
                    "label": "MAYURESWAR - I"
                },
                {
                    "value": "[ 06 ] MAYURESWAR - II",
                    "label": "MAYURESWAR - II"
                },
                {
                    "value": "[ 07 ] RAMPURHAT - I",
                    "label": "RAMPURHAT - I"
                },
                {
                    "value": "[ 08 ] RAMPURHAT - II",
                    "label": "RAMPURHAT - II"
                },
                {
                    "value": "[ 09 ] MD. BAZAR",
                    "label": "MD. BAZAR"
                },
                {
                    "value": "[ 10 ] SAINTHIA",
                    "label": "SAINTHIA"
                },
                {
                    "value": "[ 11 ] BOLPUR",
                    "label": "BOLPUR"
                },
                {
                    "value": "[ 12 ] LAVPUR",
                    "label": "LAVPUR"
                },
                {
                    "value": "[ 13 ] NANOOR",
                    "label": "NANOOR"
                },
                {
                    "value": "[ 14 ] DUBRAJPUR",
                    "label": "DUBRAJPUR"
                },
                {
                    "value": "[ 15 ] ELAMBAZAR",
                    "label": "ELAMBAZAR"
                },
                {
                    "value": "[ 16 ] RAJNAGAR",
                    "label": "RAJNAGAR"
                },
                {
                    "value": "[ 17 ] SURI - I",
                    "label": "SURI - I"
                },
                {
                    "value": "[ 18 ] SURI - II",
                    "label": "SURI - II"
                },
                {
                    "value": "[ 19 ] KHAYRASOL",
                    "label": "KHAYRASOL"
                }
            ]
        }, {
            district: "[ 04 ] DARJEELING",
            blockList: [
                {
                    "value": "[ 01 ] MATIGARA",
                    "label": "MATIGARA"
                },
                {
                    "value": "[ 02 ] NAXALBARI",
                    "label": "NAXALBARI"
                },
                {
                    "value": "[ 03 ] PHANSIDEWA",
                    "label": "PHANSIDEWA"
                },
                {
                    "value": "[ 04 ] KHARIBARI",
                    "label": "KHARIBARI"
                },
                {
                    "value": "[ 05 ] SILIGURI TOWN",
                    "label": "SILIGURI TOWN"
                },
                {
                    "value": "[ 08 ] KARSEONG",
                    "label": "KARSEONG"
                },
                {
                    "value": "[ 09 ] MIRIK",
                    "label": "MIRIK"
                },
                {
                    "value": "[ 10 ] BIJONBARI (DARJEELING SADAR)",
                    "label": "BIJONBARI (DARJEELING SADAR)"
                },
                {
                    "value": "[ 11 ] RANGLI RANGLIOT",
                    "label": "RANGLI RANGLIOT"
                },
                {
                    "value": "[ 12 ] SUKHIAPOKHRI",
                    "label": "SUKHIAPOKHRI"
                },
                {
                    "value": "[ 13 ] BIJONBARI (PULBAZAR)",
                    "label": "BIJONBARI (PULBAZAR)"
                }
            ]
        },
        {
            district: "[ 05 ] HAORA",
            blockList: [
                {
                    "value": "[ 01 ] DOMJUR",
                    "label": "DOMJUR"
                },
                {
                    "value": "[ 02 ] JAGATBALLAVPUR",
                    "label": "JAGATBALLAVPUR"
                },
                {
                    "value": "[ 03 ] BALI-JAGACHA",
                    "label": "BALI-JAGACHA"
                },
                {
                    "value": "[ 04 ] SANKRAIL",
                    "label": "SANKRAIL"
                },
                {
                    "value": "[ 05 ] PANCHLA",
                    "label": "PANCHLA"
                },
                {
                    "value": "[ 06 ] AMTA-I",
                    "label": "AMTA-I"
                },
                {
                    "value": "[ 07 ] AMTA-II",
                    "label": "AMTA-II"
                },
                {
                    "value": "[ 08 ] BAGNAN-I",
                    "label": "BAGNAN-I"
                },
                {
                    "value": "[ 09 ] BAGNAN-II",
                    "label": "BAGNAN-II"
                },
                {
                    "value": "[ 10 ] UDAYNARAYANPUR",
                    "label": "UDAYNARAYANPUR"
                },
                {
                    "value": "[ 11 ] ULUBERIA-I",
                    "label": "ULUBERIA-I"
                },
                {
                    "value": "[ 12 ] ULUBERIA-II",
                    "label": "ULUBERIA-II"
                },
                {
                    "value": "[ 13 ] SHYAMPUR-I",
                    "label": "SHYAMPUR-I"
                },
                {
                    "value": "[ 14 ] SHYAMPUR-II",
                    "label": "SHYAMPUR-II"
                },
                {
                    "value": "[ 15 ] HAORA TOWN SURVEY UNIT",
                    "label": "HAORA TOWN SURVEY UNIT"
                }
            ]
        }, {
            district: "[ 06 ] HUGLI",
            blockList: [
                {
                    "value": "[ 01 ] MOGRA CHINSURA",
                    "label": "MOGRA CHINSURA"
                },
                {
                    "value": "[ 02 ] POLBA - DADPUR",
                    "label": "POLBA - DADPUR"
                },
                {
                    "value": "[ 03 ] DHANIAKHALI",
                    "label": "DHANIAKHALI"
                },
                {
                    "value": "[ 04 ] PANDUA",
                    "label": "PANDUA"
                },
                {
                    "value": "[ 05 ] BALAGARH",
                    "label": "BALAGARH"
                },
                {
                    "value": "[ 06 ] SINGUR",
                    "label": "SINGUR"
                },
                {
                    "value": "[ 07 ] HARIPAL",
                    "label": "HARIPAL"
                },
                {
                    "value": "[ 08 ] TARAKESWAR",
                    "label": "TARAKESWAR"
                },
                {
                    "value": "[ 09 ] SHRIRAMPUR",
                    "label": "SHRIRAMPUR"
                },
                {
                    "value": "[ 10 ] CHANDITALA - I",
                    "label": "CHANDITALA - I"
                },
                {
                    "value": "[ 11 ] CHANDITALA - II",
                    "label": "CHANDITALA - II"
                },
                {
                    "value": "[ 12 ] JANGIPARA",
                    "label": "JANGIPARA"
                },
                {
                    "value": "[ 13 ] GOGHAT - I",
                    "label": "GOGHAT - I"
                },
                {
                    "value": "[ 14 ] GOGHAT - II",
                    "label": "GOGHAT - II"
                },
                {
                    "value": "[ 15 ] ARAMBAGH",
                    "label": "ARAMBAGH"
                },
                {
                    "value": "[ 16 ] KHANAKUL - I",
                    "label": "KHANAKUL - I"
                },
                {
                    "value": "[ 17 ] KHANAKUL - II",
                    "label": "KHANAKUL - II"
                },
                {
                    "value": "[ 18 ] PURSHURA",
                    "label": "PURSHURA"
                },
                {
                    "value": "[ 19 ] Singur (Khalisani)",
                    "label": "Singur (Khalisani)"
                }
            ]
        }, {
            district: "[ 07 ] JALPAIGURI",
            blockList: [
                {
                    "value": "[ 01 ] RAJGANJ",
                    "label": "RAJGANJ"
                },
                {
                    "value": "[ 02 ] JALPAIGURI SADAR",
                    "label": "JALPAIGURI SADAR"
                },
                {
                    "value": "[ 03 ] MOYNAGURI",
                    "label": "MOYNAGURI"
                },
                {
                    "value": "[ 04 ] DHUPGURI",
                    "label": "DHUPGURI"
                },
                {
                    "value": "[ 05 ] MALBAZAR",
                    "label": "MALBAZAR"
                },
                {
                    "value": "[ 06 ] METIALI",
                    "label": "METIALI"
                },
                {
                    "value": "[ 07 ] NAGRAKATA",
                    "label": "NAGRAKATA"
                }
            ]
        }, {
            district: "[ 08 ] COOCHBIHAR",
            blockList: [
                {
                    "value": "[ 01 ] KOOCHBIHAR - I",
                    "label": "KOOCHBIHAR - I"
                },
                {
                    "value": "[ 02 ] KOOCHBIHAR - II",
                    "label": "KOOCHBIHAR - II"
                },
                {
                    "value": "[ 03 ] TUFANGANJ - I",
                    "label": "TUFANGANJ - I"
                },
                {
                    "value": "[ 04 ] TUFANGANJ - II",
                    "label": "TUFANGANJ - II"
                },
                {
                    "value": "[ 05 ] DINHATA - I",
                    "label": "DINHATA - I"
                },
                {
                    "value": "[ 06 ] DINHATA - II",
                    "label": "DINHATA - II"
                },
                {
                    "value": "[ 07 ] SITAI",
                    "label": "SITAI"
                },
                {
                    "value": "[ 08 ] HALDIBARI",
                    "label": "HALDIBARI"
                },
                {
                    "value": "[ 09 ] MEKHLIGANJ",
                    "label": "MEKHLIGANJ"
                },
                {
                    "value": "[ 10 ] MATHABANGA - I",
                    "label": "MATHABANGA - I"
                },
                {
                    "value": "[ 11 ] MATHABANGA - II",
                    "label": "MATHABANGA - II"
                },
                {
                    "value": "[ 12 ] SITALKUCHI",
                    "label": "SITALKUCHI"
                }
            ]
        },
        {
            district: "[ 09 ] MALDA",
            blockList: [
                {
                    "value": "[ 01 ] HARISHCHANDRAPUR-1",
                    "label": "HARISHCHANDRAPUR-1"
                },
                {
                    "value": "[ 02 ] HARISHCHANDRAPUR-2",
                    "label": "HARISHCHANDRAPUR-2"
                },
                {
                    "value": "[ 03 ] CHANCHAL-I",
                    "label": "CHANCHAL-I"
                },
                {
                    "value": "[ 04 ] CHANCHAL-II",
                    "label": "CHANCHAL-II"
                },
                {
                    "value": "[ 05 ] RATUA-I",
                    "label": "RATUA-I"
                },
                {
                    "value": "[ 06 ] RATUA-2",
                    "label": "RATUA-2"
                },
                {
                    "value": "[ 07 ] MANIKCHAK",
                    "label": "MANIKCHAK"
                },
                {
                    "value": "[ 08 ] OLD MALDA",
                    "label": "OLD MALDA"
                },
                {
                    "value": "[ 09 ] GAZOLE",
                    "label": "GAZOLE"
                },
                {
                    "value": "[ 10 ] BAMANGOLA",
                    "label": "BAMANGOLA"
                },
                {
                    "value": "[ 11 ] HABIBPUR",
                    "label": "HABIBPUR"
                },
                {
                    "value": "[ 12 ] ENGLISHBAZAR",
                    "label": "ENGLISHBAZAR"
                },
                {
                    "value": "[ 13 ] KALIACHAK-1",
                    "label": "KALIACHAK-1"
                },
                {
                    "value": "[ 14 ] KALIACHAK-II",
                    "label": "KALIACHAK-II"
                },
                {
                    "value": "[ 15 ] KALIACHAK-3",
                    "label": "KALIACHAK-3"
                }
            ]
        },
        {
            district: "[ 10 ] PASCHIM MEDINIPUR",
            blockList: [
                {
                    "value": "[ 09 ] KHARGAPUR-I",
                    "label": "KHARGAPUR-I"
                },
                {
                    "value": "[ 10 ] KHARGAPUR-II",
                    "label": "KHARGAPUR-II"
                },
                {
                    "value": "[ 11 ] KESHIARI",
                    "label": "KESHIARI"
                },
                {
                    "value": "[ 12 ] NARAYANGARH",
                    "label": "NARAYANGARH"
                },
                {
                    "value": "[ 13 ] DATAN-I",
                    "label": "DATAN-I"
                },
                {
                    "value": "[ 14 ] DATAN-II",
                    "label": "DATAN-II"
                },
                {
                    "value": "[ 15 ] MOHANPUR",
                    "label": "MOHANPUR"
                },
                {
                    "value": "[ 16 ] PINGLA",
                    "label": "PINGLA"
                },
                {
                    "value": "[ 17 ] SABANG",
                    "label": "SABANG"
                },
                {
                    "value": "[ 18 ] DEBRA",
                    "label": "DEBRA"
                },
                {
                    "value": "[ 19 ] GARHBETA-I",
                    "label": "GARHBETA-I"
                },
                {
                    "value": "[ 20 ] GARHBETA-II",
                    "label": "GARHBETA-II"
                },
                {
                    "value": "[ 21 ] GARHBETA-III",
                    "label": "GARHBETA-III"
                },
                {
                    "value": "[ 22 ] SALBONI",
                    "label": "SALBONI"
                },
                {
                    "value": "[ 23 ] KESHPUR",
                    "label": "KESHPUR"
                },
                {
                    "value": "[ 24 ] MEDINIPUR SADAR",
                    "label": "MEDINIPUR SADAR"
                },
                {
                    "value": "[ 25 ] CHANDROKONA-II",
                    "label": "CHANDROKONA-II"
                },
                {
                    "value": "[ 26 ] CHANDROKONA-I",
                    "label": "CHANDROKONA-I"
                },
                {
                    "value": "[ 27 ] GHATAL",
                    "label": "GHATAL"
                },
                {
                    "value": "[ 28 ] DASPUR-I",
                    "label": "DASPUR-I"
                },
                {
                    "value": "[ 29 ] DASPUR-II",
                    "label": "DASPUR-II"
                }
            ]
        }, {
            district: "[ 11 ] PURBA MEDINIPUR",
            blockList: [
                {
                    "value": "[ 06 ] PANSHKURA-1",
                    "label": "PANSHKURA-1"
                },
                {
                    "value": "[ 07 ] PANSHKURA-2",
                    "label": "PANSHKURA-2"
                },
                {
                    "value": "[ 08 ] SAHID MATANGINI(TAMLUK-2)",
                    "label": "SAHID MATANGINI(TAMLUK-2)"
                },
                {
                    "value": "[ 09 ] TAMLUK-1",
                    "label": "TAMLUK-1"
                },
                {
                    "value": "[ 10 ] MOYNA",
                    "label": "MOYNA"
                },
                {
                    "value": "[ 11 ] MAHISHADAL",
                    "label": "MAHISHADAL"
                },
                {
                    "value": "[ 12 ] NANDAKUMAR",
                    "label": "NANDAKUMAR"
                },
                {
                    "value": "[ 13 ] SUTAHATA-1",
                    "label": "SUTAHATA-1"
                },
                {
                    "value": "[ 14 ] SUTAHATA-2",
                    "label": "SUTAHATA-2"
                },
                {
                    "value": "[ 15 ] NANDIGRAM-1",
                    "label": "NANDIGRAM-1"
                },
                {
                    "value": "[ 16 ] NANDIGRAM-2",
                    "label": "NANDIGRAM-2"
                },
                {
                    "value": "[ 17 ] NANDIGRAM-3",
                    "label": "NANDIGRAM-3"
                },
                {
                    "value": "[ 18 ] BHAGABANPUR-1",
                    "label": "BHAGABANPUR-1"
                },
                {
                    "value": "[ 19 ] BHAGABANPUR-2",
                    "label": "BHAGABANPUR-2"
                },
                {
                    "value": "[ 20 ] KHEJURI-1",
                    "label": "KHEJURI-1"
                },
                {
                    "value": "[ 21 ] KHEJURI-2",
                    "label": "KHEJURI-2"
                },
                {
                    "value": "[ 22 ] CONTAI-2",
                    "label": "CONTAI-2"
                },
                {
                    "value": "[ 23 ] CONTAI-1",
                    "label": "CONTAI-1"
                },
                {
                    "value": "[ 24 ] CONTAI-3",
                    "label": "CONTAI-3"
                },
                {
                    "value": "[ 25 ] PATASHPUR-1",
                    "label": "PATASHPUR-1"
                },
                {
                    "value": "[ 26 ] PATASHPUR-2",
                    "label": "PATASHPUR-2"
                },
                {
                    "value": "[ 27 ] EGRA-1",
                    "label": "EGRA-1"
                },
                {
                    "value": "[ 28 ] EGRA-2",
                    "label": "EGRA-2"
                },
                {
                    "value": "[ 29 ] RAMNAGAR-1",
                    "label": "RAMNAGAR-1"
                },
                {
                    "value": "[ 30 ] RAMNAGAR-2",
                    "label": "RAMNAGAR-2"
                }
            ]
        },
        {
            district: "[ 12 ] MURSHIDABAD",
            blockList: [
                {
                    "value": "[ 01 ] BELDANGA - I",
                    "label": "BELDANGA - I"
                },
                {
                    "value": "[ 02 ] BELDANGA - II",
                    "label": "BELDANGA - II"
                },
                {
                    "value": "[ 03 ] BERHAMPUR SADAR",
                    "label": "BERHAMPUR SADAR"
                },
                {
                    "value": "[ 04 ] BHAGABANGOLA - I",
                    "label": "BHAGABANGOLA - I"
                },
                {
                    "value": "[ 05 ] BHAGABANGOLA - II",
                    "label": "BHAGABANGOLA - II"
                },
                {
                    "value": "[ 06 ] BHARATPUR - I",
                    "label": "BHARATPUR - I"
                },
                {
                    "value": "[ 07 ] BHARATPUR - II",
                    "label": "BHARATPUR - II"
                },
                {
                    "value": "[ 08 ] BURWAN",
                    "label": "BURWAN"
                },
                {
                    "value": "[ 09 ] DOMKAL",
                    "label": "DOMKAL"
                },
                {
                    "value": "[ 10 ] FARAKKA",
                    "label": "FARAKKA"
                },
                {
                    "value": "[ 11 ] HARIHARPARA",
                    "label": "HARIHARPARA"
                },
                {
                    "value": "[ 12 ] JALANGI",
                    "label": "JALANGI"
                },
                {
                    "value": "[ 13 ] KANDI",
                    "label": "KANDI"
                },
                {
                    "value": "[ 14 ] KHARGRAM",
                    "label": "KHARGRAM"
                },
                {
                    "value": "[ 15 ] LALGOLA",
                    "label": "LALGOLA"
                },
                {
                    "value": "[ 16 ] MURSHIDABAD JIAGANJ",
                    "label": "MURSHIDABAD JIAGANJ"
                },
                {
                    "value": "[ 17 ] NABAGRAM",
                    "label": "NABAGRAM"
                },
                {
                    "value": "[ 18 ] NOWDA",
                    "label": "NOWDA"
                },
                {
                    "value": "[ 19 ] RAGHNATHGUNJ - I",
                    "label": "RAGHNATHGUNJ - I"
                },
                {
                    "value": "[ 20 ] RAGHNATHGUNJ - II",
                    "label": "RAGHNATHGUNJ - II"
                },
                {
                    "value": "[ 21 ] RANINAGAR - I",
                    "label": "RANINAGAR - I"
                },
                {
                    "value": "[ 22 ] RANINAGAR - II",
                    "label": "RANINAGAR - II"
                },
                {
                    "value": "[ 23 ] SAGARDIGHI",
                    "label": "SAGARDIGHI"
                },
                {
                    "value": "[ 24 ] SAMSERGANJ",
                    "label": "SAMSERGANJ"
                },
                {
                    "value": "[ 25 ] SUTI - I",
                    "label": "SUTI - I"
                },
                {
                    "value": "[ 26 ] SUTI - II",
                    "label": "SUTI - II"
                }
            ]
        },
        {
            district: "[ 13 ] NADIA",
            blockList: [
                {
                    "value": "[ 01 ] CHAKDAHA",
                    "label": "CHAKDAHA"
                },
                {
                    "value": "[ 02 ] CHAPRA",
                    "label": "CHAPRA"
                },
                {
                    "value": "[ 03 ] HANSKHALI",
                    "label": "HANSKHALI"
                },
                {
                    "value": "[ 04 ] HARINGHATA",
                    "label": "HARINGHATA"
                },
                {
                    "value": "[ 05 ] KALIGUNJ",
                    "label": "KALIGUNJ"
                },
                {
                    "value": "[ 06 ] KARIMPUR - I",
                    "label": "KARIMPUR - I"
                },
                {
                    "value": "[ 07 ] KARIMPUR - II",
                    "label": "KARIMPUR - II"
                },
                {
                    "value": "[ 08 ] KRISHNAGUNJ",
                    "label": "KRISHNAGUNJ"
                },
                {
                    "value": "[ 09 ] KRISHNANAGAR - I",
                    "label": "KRISHNANAGAR - I"
                },
                {
                    "value": "[ 10 ] KRISHNANAGAR - II",
                    "label": "KRISHNANAGAR - II"
                },
                {
                    "value": "[ 11 ] NABADWIP",
                    "label": "NABADWIP"
                },
                {
                    "value": "[ 12 ] NAKASHIPARA",
                    "label": "NAKASHIPARA"
                },
                {
                    "value": "[ 13 ] RANAGHAT - I",
                    "label": "RANAGHAT - I"
                },
                {
                    "value": "[ 14 ] RANAGHAT - II",
                    "label": "RANAGHAT - II"
                },
                {
                    "value": "[ 15 ] SANTIPUR",
                    "label": "SANTIPUR"
                },
                {
                    "value": "[ 16 ] TEHATTA - I",
                    "label": "TEHATTA - I"
                },
                {
                    "value": "[ 17 ] TEHATTA - II",
                    "label": "TEHATTA - II"
                }
            ]
        },
        {
            district: "[ 14 ] PURULIA",
            blockList: [
                {
                    "value": "[ 01 ] PURULIA-I",
                    "label": "PURULIA-I"
                },
                {
                    "value": "[ 02 ] PURULIA-II",
                    "label": "PURULIA-II"
                },
                {
                    "value": "[ 03 ] HURA",
                    "label": "HURA"
                },
                {
                    "value": "[ 04 ] PUNCHA",
                    "label": "PUNCHA"
                },
                {
                    "value": "[ 05 ] MANBAZAR-I",
                    "label": "MANBAZAR-I"
                },
                {
                    "value": "[ 06 ] MANBAZAR-II",
                    "label": "MANBAZAR-II"
                },
                {
                    "value": "[ 07 ] BANDWAN",
                    "label": "BANDWAN"
                },
                {
                    "value": "[ 08 ] ARSHA",
                    "label": "ARSHA"
                },
                {
                    "value": "[ 09 ] BALARAMPUR",
                    "label": "BALARAMPUR"
                },
                {
                    "value": "[ 10 ] BAGMUNDI",
                    "label": "BAGMUNDI"
                },
                {
                    "value": "[ 11 ] BARABAZAR",
                    "label": "BARABAZAR"
                },
                {
                    "value": "[ 12 ] JAYPUR",
                    "label": "JAYPUR"
                },
                {
                    "value": "[ 13 ] JHALDA-I",
                    "label": "JHALDA-I"
                },
                {
                    "value": "[ 14 ] JHALDA-II",
                    "label": "JHALDA-II"
                },
                {
                    "value": "[ 15 ] RAGHUNATHPUR-I",
                    "label": "RAGHUNATHPUR-I"
                },
                {
                    "value": "[ 16 ] RAGHUNATHPUR-II",
                    "label": "RAGHUNATHPUR-II"
                },
                {
                    "value": "[ 17 ] PARA",
                    "label": "PARA"
                },
                {
                    "value": "[ 18 ] KASHIPUR",
                    "label": "KASHIPUR"
                },
                {
                    "value": "[ 19 ] NETURIA",
                    "label": "NETURIA"
                },
                {
                    "value": "[ 20 ] SANTURI",
                    "label": "SANTURI"
                }
            ]
        },
        {
            district: "[ 15 ] UTTAR 24 PARGANA",
            blockList: [
                {
                    "value": "[ 01 ] AMDANGA",
                    "label": "AMDANGA"
                },
                {
                    "value": "[ 02 ] BARASAT-1",
                    "label": "BARASAT-1"
                },
                {
                    "value": "[ 03 ] BARASAT-2",
                    "label": "BARASAT-2"
                },
                {
                    "value": "[ 04 ] DEGANGA",
                    "label": "DEGANGA"
                },
                {
                    "value": "[ 05 ] HABRA-1",
                    "label": "HABRA-1"
                },
                {
                    "value": "[ 06 ] HABRA-2",
                    "label": "HABRA-2"
                },
                {
                    "value": "[ 07 ] RAJARHAT",
                    "label": "RAJARHAT"
                },
                {
                    "value": "[ 08 ] BARRACKPUR-1",
                    "label": "BARRACKPUR-1"
                },
                {
                    "value": "[ 09 ] BARRACKPUR-2",
                    "label": "BARRACKPUR-2"
                },
                {
                    "value": "[ 10 ] BADURIA",
                    "label": "BADURIA"
                },
                {
                    "value": "[ 11 ] BASIRHAT-1",
                    "label": "BASIRHAT-1"
                },
                {
                    "value": "[ 12 ] BASIRHAT-2",
                    "label": "BASIRHAT-2"
                },
                {
                    "value": "[ 13 ] HAROA",
                    "label": "HAROA"
                },
                {
                    "value": "[ 14 ] HASNABAD",
                    "label": "HASNABAD"
                },
                {
                    "value": "[ 15 ] HINGALGANJ",
                    "label": "HINGALGANJ"
                },
                {
                    "value": "[ 16 ] MINAKHAN",
                    "label": "MINAKHAN"
                },
                {
                    "value": "[ 17 ] SANDESHKHALI-1",
                    "label": "SANDESHKHALI-1"
                },
                {
                    "value": "[ 18 ] SANDESHKHALI-2",
                    "label": "SANDESHKHALI-2"
                },
                {
                    "value": "[ 19 ] SWARUPNAGAR",
                    "label": "SWARUPNAGAR"
                },
                {
                    "value": "[ 20 ] BANGA",
                    "label": "BANGA"
                },
                {
                    "value": "[ 21 ] BAGDA",
                    "label": "BAGDA"
                },
                {
                    "value": "[ 22 ] GAIGHATA",
                    "label": "GAIGHATA"
                }
            ]
        },
        {
            district: "[ 16 ] DAKSHIN 24 PARGANA",
            blockList: [
                {
                    "value": "[ 01 ] BARUIPUR",
                    "label": "BARUIPUR"
                },
                {
                    "value": "[ 02 ] BHANGAR-I",
                    "label": "BHANGAR-I"
                },
                {
                    "value": "[ 03 ] BHANGAR-II",
                    "label": "BHANGAR-II"
                },
                {
                    "value": "[ 04 ] BISHNUPUR-I",
                    "label": "BISHNUPUR-I"
                },
                {
                    "value": "[ 05 ] BISHNUPUR-II",
                    "label": "BISHNUPUR-II"
                },
                {
                    "value": "[ 06 ] BUDGE-BUDGE-I",
                    "label": "BUDGE-BUDGE-I"
                },
                {
                    "value": "[ 07 ] BUDGE-BUDGE-II",
                    "label": "BUDGE-BUDGE-II"
                },
                {
                    "value": "[ 08 ] BASANTI",
                    "label": "BASANTI"
                },
                {
                    "value": "[ 09 ] CANNING-I",
                    "label": "CANNING-I"
                },
                {
                    "value": "[ 10 ] CANNING-II",
                    "label": "CANNING-II"
                },
                {
                    "value": "[ 11 ] JAYNAGAR-I",
                    "label": "JAYNAGAR-I"
                },
                {
                    "value": "[ 12 ] JAYNAGAR-II",
                    "label": "JAYNAGAR-II"
                },
                {
                    "value": "[ 13 ] KULTALI",
                    "label": "KULTALI"
                },
                {
                    "value": "[ 14 ] MAHESHTALA",
                    "label": "MAHESHTALA"
                },
                {
                    "value": "[ 15 ] SONARPUR",
                    "label": "SONARPUR"
                },
                {
                    "value": "[ 16 ] GOSABA",
                    "label": "GOSABA"
                },
                {
                    "value": "[ 17 ] DIAMOND HARBOUR-I",
                    "label": "DIAMOND HARBOUR-I"
                },
                {
                    "value": "[ 18 ] DIAMOND HARBOUR-II",
                    "label": "DIAMOND HARBOUR-II"
                },
                {
                    "value": "[ 19 ] MATHURAPUR-I",
                    "label": "MATHURAPUR-I"
                },
                {
                    "value": "[ 20 ] MATHURAPUR-II",
                    "label": "MATHURAPUR-II"
                },
                {
                    "value": "[ 21 ] MOGRAHAT-I",
                    "label": "MOGRAHAT-I"
                },
                {
                    "value": "[ 22 ] MAGRAHAT-II",
                    "label": "MAGRAHAT-II"
                },
                {
                    "value": "[ 23 ] MANDIRBAZAR",
                    "label": "MANDIRBAZAR"
                },
                {
                    "value": "[ 24 ] NAMKHANA",
                    "label": "NAMKHANA"
                },
                {
                    "value": "[ 25 ] KULPI",
                    "label": "KULPI"
                },
                {
                    "value": "[ 26 ] KAKDWIP",
                    "label": "KAKDWIP"
                },
                {
                    "value": "[ 27 ] PATHARPRATIMA",
                    "label": "PATHARPRATIMA"
                },
                {
                    "value": "[ 28 ] PHALTA",
                    "label": "PHALTA"
                },
                {
                    "value": "[ 29 ] SAGAR",
                    "label": "SAGAR"
                },
                {
                    "value": "[ 30 ] Kolkata",
                    "label": "Kolkata"
                }
            ]
        },
        {
            district: "[ 17 ] DAKSHIN DINAJPUR",
            blockList: [
                {
                    "value": "[ 01 ] BALURGHAT",
                    "label": "BALURGHAT"
                },
                {
                    "value": "[ 02 ] HILI",
                    "label": "HILI"
                },
                {
                    "value": "[ 03 ] KUMARGANJ",
                    "label": "KUMARGANJ"
                },
                {
                    "value": "[ 04 ] TAPAN",
                    "label": "TAPAN"
                },
                {
                    "value": "[ 05 ] GANGARAMPUR",
                    "label": "GANGARAMPUR"
                },
                {
                    "value": "[ 06 ] BANSHIHARI",
                    "label": "BANSHIHARI"
                },
                {
                    "value": "[ 07 ] HARIRAMPUR",
                    "label": "HARIRAMPUR"
                },
                {
                    "value": "[ 08 ] KUSHMUNDI",
                    "label": "KUSHMUNDI"
                }
            ]
        },
        {
            district: "[ 18 ] UTTAR DINAJPUR",
            blockList: [
                {
                    "value": "[ 01 ] CHOPRA",
                    "label": "CHOPRA"
                },
                {
                    "value": "[ 02 ] ISLAMPUR",
                    "label": "ISLAMPUR"
                },
                {
                    "value": "[ 03 ] GOALPOKHAR-I",
                    "label": "GOALPOKHAR-I"
                },
                {
                    "value": "[ 04 ] GOALPOKHAR-II",
                    "label": "GOALPOKHAR-II"
                },
                {
                    "value": "[ 05 ] KARANDIGHI",
                    "label": "KARANDIGHI"
                },
                {
                    "value": "[ 06 ] RAIGANJ",
                    "label": "RAIGANJ"
                },
                {
                    "value": "[ 07 ] HEMTABAD",
                    "label": "HEMTABAD"
                },
                {
                    "value": "[ 08 ] KALIAGANJ",
                    "label": "KALIAGANJ"
                },
                {
                    "value": "[ 09 ] ITAHAR",
                    "label": "ITAHAR"
                }
            ]
        },
        {
            district: "[ 19 ] Kolkata",
            blockList: [{
                "value": "[ 01 ] Kolkata",
                "label": "Kolkata"
            }]
        },
        {
            district: "[ 20 ] ALIPURDUAR",
            blockList: [
                {
                    "value": "[ 01 ] PHALAKATA",
                    "label": "PHALAKATA"
                },
                {
                    "value": "[ 02 ] MADARIHAT",
                    "label": "MADARIHAT"
                },
                {
                    "value": "[ 03 ] KALCHINI",
                    "label": "KALCHINI"
                },
                {
                    "value": "[ 04 ] ALIPURDUAR-1",
                    "label": "ALIPURDUAR-1"
                },
                {
                    "value": "[ 05 ] ALIPURDUAR-2",
                    "label": "ALIPURDUAR-2"
                },
                {
                    "value": "[ 06 ] KUMARGRAM",
                    "label": "KUMARGRAM"
                }
            ]
        },
        {
            district: "[ 21 ] KALIMPONG",
            blockList: [
                {
                    "value": "[ 01 ] KALIMPONG-I",
                    "label": "KALIMPONG-I"
                },
                {
                    "value": "[ 02 ] KALIMPONG-II",
                    "label": "KALIMPONG-II"
                },
                {
                    "value": "[ 03 ] KALIMPONG-III",
                    "label": "KALIMPONG-III"
                }
            ]
        },
        {
            district: "[ 22 ] JHARGRAM",
            blockList: [
                {
                    "value": "[ 01 ] NAYAGRAM",
                    "label": "NAYAGRAM"
                },
                {
                    "value": "[ 02 ] GOPIBALLAVPUR-I",
                    "label": "GOPIBALLAVPUR-I"
                },
                {
                    "value": "[ 03 ] GOPIBALLAVPUR-II",
                    "label": "GOPIBALLAVPUR-II"
                },
                {
                    "value": "[ 04 ] SANKRAIL",
                    "label": "SANKRAIL"
                },
                {
                    "value": "[ 05 ] JHARGRAM",
                    "label": "JHARGRAM"
                },
                {
                    "value": "[ 06 ] JAMBONI",
                    "label": "JAMBONI"
                },
                {
                    "value": "[ 07 ] BINPUR-I",
                    "label": "BINPUR-I"
                },
                {
                    "value": "[ 08 ] BINPUR-II",
                    "label": "BINPUR-II"
                }
            ]
        },
        {
            district: "[ 23 ] PASCHIM BARDHAMAN",
            blockList: [
                {
                    "value": "[ 01 ] ANDAL",
                    "label": "ANDAL"
                },
                {
                    "value": "[ 02 ] FARIDPUR-DURGAPUR",
                    "label": "FARIDPUR-DURGAPUR"
                },
                {
                    "value": "[ 03 ] KANKSA",
                    "label": "KANKSA"
                },
                {
                    "value": "[ 04 ] PANDABESWAR",
                    "label": "PANDABESWAR"
                },
                {
                    "value": "[ 05 ] ASANSOLE",
                    "label": "ASANSOLE"
                },
                {
                    "value": "[ 06 ] BARABONI",
                    "label": "BARABONI"
                },
                {
                    "value": "[ 07 ] JAMURIA",
                    "label": "JAMURIA"
                },
                {
                    "value": "[ 08 ] KULTI",
                    "label": "KULTI"
                },
                {
                    "value": "[ 09 ] RANIGANJ",
                    "label": "RANIGANJ"
                },
                {
                    "value": "[ 10 ] SALANPUR",
                    "label": "SALANPUR"
                },
                {
                    "value": "[ 11 ] ADDITIONAL FARIDPUR-DURGAPUR",
                    "label": "ADDITIONAL FARIDPUR-DURGAPUR"
                }
            ]
        }
    ],
    mouzas: [
        {
            block: "[ 27 ] GHATAL",
            mouzaList: [
                {
                    "value": "[ 001 ] Ranjapur",
                    "label": "Ranjapur"
                },
                {
                    "value": "[ 002 ] Ramchandrapur",
                    "label": "Ramchandrapur"
                },
                {
                    "value": "[ 003 ] Narayanchak",
                    "label": "Narayanchak"
                },
                {
                    "value": "[ 004 ] Lakshmanpur",
                    "label": "Lakshmanpur"
                },
                {
                    "value": "[ 005 ] Sultanpur",
                    "label": "Sultanpur"
                },
                {
                    "value": "[ 006 ] Dewanchak",
                    "label": "Dewanchak"
                },
                {
                    "value": "[ 007 ] Soai",
                    "label": "Soai"
                },
                {
                    "value": "[ 008 ] Balidanga",
                    "label": "Balidanga"
                },
                {
                    "value": "[ 009 ] Kongra",
                    "label": "Kongra"
                },
                {
                    "value": "[ 010 ] Srimantapur",
                    "label": "Srimantapur"
                },
                {
                    "value": "[ 011 ] Balarampur",
                    "label": "Balarampur"
                },
                {
                    "value": "[ 012 ] Anandapur",
                    "label": "Anandapur"
                },
                {
                    "value": "[ 013 ] Prasadchak",
                    "label": "Prasadchak"
                },
                {
                    "value": "[ 014 ] Amadarkul",
                    "label": "Amadarkul"
                },
                {
                    "value": "[ 015 ] Khasbarh",
                    "label": "Khasbarh"
                },
                {
                    "value": "[ 016 ] Joybag",
                    "label": "Joybag"
                },
                {
                    "value": "[ 017 ] Irhpala",
                    "label": "Irhpala"
                },
                {
                    "value": "[ 018 ] Kalisa",
                    "label": "Kalisa"
                },
                {
                    "value": "[ 019 ] Gobindapur",
                    "label": "Gobindapur"
                },
                {
                    "value": "[ 020 ] Shyamchak",
                    "label": "Shyamchak"
                },
                {
                    "value": "[ 021 ] Joykundu",
                    "label": "Joykundu"
                },
                {
                    "value": "[ 022 ] Dhasachandpur",
                    "label": "Dhasachandpur"
                },
                {
                    "value": "[ 023 ] Baghanala",
                    "label": "Baghanala"
                },
                {
                    "value": "[ 024 ] Banaharisingpur",
                    "label": "Banaharisingpur"
                },
                {
                    "value": "[ 025 ] Mansuka",
                    "label": "Mansuka"
                },
                {
                    "value": "[ 026 ] Doulatchak",
                    "label": "Doulatchak"
                },
                {
                    "value": "[ 027 ] Chaulisingpur",
                    "label": "Chaulisingpur"
                },
                {
                    "value": "[ 028 ] Gangaprasad",
                    "label": "Gangaprasad"
                },
                {
                    "value": "[ 029 ] Srirampur",
                    "label": "Srirampur"
                },
                {
                    "value": "[ 030 ] Garhpratapnagar",
                    "label": "Garhpratapnagar"
                },
                {
                    "value": "[ 031 ] Nischindipur",
                    "label": "Nischindipur"
                },
                {
                    "value": "[ 032 ] Gombhirnagar",
                    "label": "Gombhirnagar"
                },
                {
                    "value": "[ 033 ] Chauli",
                    "label": "Chauli"
                },
                {
                    "value": "[ 034 ] Lalkundu",
                    "label": "Lalkundu"
                },
                {
                    "value": "[ 035 ] Brindabanchak",
                    "label": "Brindabanchak"
                },
                {
                    "value": "[ 036 ] Ajodhyakundu",
                    "label": "Ajodhyakundu"
                },
                {
                    "value": "[ 037 ] Dirghagram",
                    "label": "Dirghagram"
                },
                {
                    "value": "[ 038 ] Kismat Dirghagram",
                    "label": "Kismat Dirghagram"
                },
                {
                    "value": "[ 039 ] Rahatpur",
                    "label": "Rahatpur"
                },
                {
                    "value": "[ 040 ] Arjikrishnabati",
                    "label": "Arjikrishnabati"
                },
                {
                    "value": "[ 041 ] Jadupur",
                    "label": "Jadupur"
                },
                {
                    "value": "[ 042 ] Krishnabati",
                    "label": "Krishnabati"
                },
                {
                    "value": "[ 043 ] Dalapatipur",
                    "label": "Dalapatipur"
                },
                {
                    "value": "[ 044 ] Kharar (Mu)",
                    "label": "Kharar (Mu)"
                },
                {
                    "value": "[ 045 ] Kamdevpur",
                    "label": "Kamdevpur"
                },
                {
                    "value": "[ 046 ] Kuran",
                    "label": "Kuran"
                },
                {
                    "value": "[ 047 ] Udayganj",
                    "label": "Udayganj"
                },
                {
                    "value": "[ 048 ] Birsingha",
                    "label": "Birsingha"
                },
                {
                    "value": "[ 049 ] Pathra",
                    "label": "Pathra"
                },
                {
                    "value": "[ 050 ] Kanchiya",
                    "label": "Kanchiya"
                },
                {
                    "value": "[ 051 ] Kungarsaha",
                    "label": "Kungarsaha"
                },
                {
                    "value": "[ 052 ] Arjunari",
                    "label": "Arjunari"
                },
                {
                    "value": "[ 053 ] Mamarajpur",
                    "label": "Mamarajpur"
                },
                {
                    "value": "[ 054 ] Khararsingpur (Uttar)",
                    "label": "Khararsingpur (Uttar)"
                },
                {
                    "value": "[ 055 ] Gopinathpur",
                    "label": "Gopinathpur"
                },
                {
                    "value": "[ 056 ] Khararsingpur (Dakshin)",
                    "label": "Khararsingpur (Dakshin)"
                },
                {
                    "value": "[ 057 ] Marichya",
                    "label": "Marichya"
                },
                {
                    "value": "[ 058 ] Raghunathkundu",
                    "label": "Raghunathkundu"
                },
                {
                    "value": "[ 059 ] Nirmalbazar",
                    "label": "Nirmalbazar"
                },
                {
                    "value": "[ 060 ] Rathipur",
                    "label": "Rathipur"
                },
                {
                    "value": "[ 061 ] Thakuranichak",
                    "label": "Thakuranichak"
                },
                {
                    "value": "[ 062 ] Dandipur",
                    "label": "Dandipur"
                },
                {
                    "value": "[ 063 ] Shyamsundarpur",
                    "label": "Shyamsundarpur"
                },
                {
                    "value": "[ 064 ] Sukchandrapur",
                    "label": "Sukchandrapur"
                },
                {
                    "value": "[ 065 ] Argora",
                    "label": "Argora"
                },
                {
                    "value": "[ 066 ] Shyampur",
                    "label": "Shyampur"
                },
                {
                    "value": "[ 067 ] Veribalaramkundu",
                    "label": "Veribalaramkundu"
                },
                {
                    "value": "[ 068 ] Ajabnagar",
                    "label": "Ajabnagar"
                },
                {
                    "value": "[ 069 ] Shibpur Hazrapara",
                    "label": "Shibpur Hazrapara"
                },
                {
                    "value": "[ 070 ] Balaramgarh",
                    "label": "Balaramgarh"
                },
                {
                    "value": "[ 071 ] Ranir Bazar",
                    "label": "Ranir Bazar"
                },
                {
                    "value": "[ 072 ] Kharika",
                    "label": "Kharika"
                },
                {
                    "value": "[ 073 ] Jalsora",
                    "label": "Jalsora"
                },
                {
                    "value": "[ 074 ] Shimulia",
                    "label": "Shimulia"
                },
                {
                    "value": "[ 075 ] Mulgram",
                    "label": "Mulgram"
                },
                {
                    "value": "[ 076 ] Hemnagar",
                    "label": "Hemnagar"
                },
                {
                    "value": "[ 077 ] Amarpur Raghunathpur",
                    "label": "Amarpur Raghunathpur"
                },
                {
                    "value": "[ 078 ] Radhanagar",
                    "label": "Radhanagar"
                },
                {
                    "value": "[ 079 ] Nischindapur",
                    "label": "Nischindapur"
                },
                {
                    "value": "[ 080 ] Iyakubpur",
                    "label": "Iyakubpur"
                },
                {
                    "value": "[ 081 ] Shyampur",
                    "label": "Shyampur"
                },
                {
                    "value": "[ 082 ] Dighaanandapur",
                    "label": "Dighaanandapur"
                },
                {
                    "value": "[ 083 ] Alui",
                    "label": "Alui"
                },
                {
                    "value": "[ 084 ] Kushman",
                    "label": "Kushman"
                },
                {
                    "value": "[ 085 ] Natuk Joykrishnapur",
                    "label": "Natuk Joykrishnapur"
                },
                {
                    "value": "[ 086 ] Harekrishnapur",
                    "label": "Harekrishnapur"
                },
                {
                    "value": "[ 087 ] Iswarpur",
                    "label": "Iswarpur"
                },
                {
                    "value": "[ 088 ] Harinageria",
                    "label": "Harinageria"
                },
                {
                    "value": "[ 089 ] Mohanpur",
                    "label": "Mohanpur"
                },
                {
                    "value": "[ 090 ] Kharigera",
                    "label": "Kharigera"
                },
                {
                    "value": "[ 091 ] Srirampur",
                    "label": "Srirampur"
                },
                {
                    "value": "[ 092 ] Kamargeria",
                    "label": "Kamargeria"
                },
                {
                    "value": "[ 093 ] Dantiara",
                    "label": "Dantiara"
                },
                {
                    "value": "[ 094 ] Mohanchak",
                    "label": "Mohanchak"
                },
                {
                    "value": "[ 095 ] Belswar",
                    "label": "Belswar"
                },
                {
                    "value": "[ 096 ] Lachipur",
                    "label": "Lachipur"
                },
                {
                    "value": "[ 097 ] Chaklachipur",
                    "label": "Chaklachipur"
                },
                {
                    "value": "[ 098 ] Chaksadi",
                    "label": "Chaksadi"
                },
                {
                    "value": "[ 099 ] Kongarpur",
                    "label": "Kongarpur"
                },
                {
                    "value": "[ 100 ] Gholsai",
                    "label": "Gholsai"
                },
                {
                    "value": "[ 101 ] Kismat Kotalpur",
                    "label": "Kismat Kotalpur"
                },
                {
                    "value": "[ 102 ] Kotalpur",
                    "label": "Kotalpur"
                },
                {
                    "value": "[ 103 ] Kshudramonaharpur",
                    "label": "Kshudramonaharpur"
                },
                {
                    "value": "[ 104 ] Raghunathpur",
                    "label": "Raghunathpur"
                },
                {
                    "value": "[ 105 ] Krishnaballavpur",
                    "label": "Krishnaballavpur"
                },
                {
                    "value": "[ 106 ] Dewanchak",
                    "label": "Dewanchak"
                },
                {
                    "value": "[ 107 ] Jamira",
                    "label": "Jamira"
                },
                {
                    "value": "[ 108 ] Bhagirathpur",
                    "label": "Bhagirathpur"
                },
                {
                    "value": "[ 109 ] Chowka",
                    "label": "Chowka"
                },
                {
                    "value": "[ 110 ] Shimulia",
                    "label": "Shimulia"
                },
                {
                    "value": "[ 111 ] Prasadchak",
                    "label": "Prasadchak"
                },
                {
                    "value": "[ 112 ] Radhaballavpur",
                    "label": "Radhaballavpur"
                },
                {
                    "value": "[ 113 ] Joykrishnapur",
                    "label": "Joykrishnapur"
                },
                {
                    "value": "[ 114 ] Radhachak",
                    "label": "Radhachak"
                },
                {
                    "value": "[ 115 ] Barhgobinda",
                    "label": "Barhgobinda"
                },
                {
                    "value": "[ 116 ] Barhanandi",
                    "label": "Barhanandi"
                },
                {
                    "value": "[ 117 ] Bhangadaha",
                    "label": "Bhangadaha"
                },
                {
                    "value": "[ 118 ] Gopalnagar",
                    "label": "Gopalnagar"
                },
                {
                    "value": "[ 119 ] Radhakantapur",
                    "label": "Radhakantapur"
                },
                {
                    "value": "[ 120 ] Panna",
                    "label": "Panna"
                },
                {
                    "value": "[ 121 ] Dubarajkundu",
                    "label": "Dubarajkundu"
                },
                {
                    "value": "[ 122 ] Mandarpur",
                    "label": "Mandarpur"
                },
                {
                    "value": "[ 123 ] Kanakpur",
                    "label": "Kanakpur"
                },
                {
                    "value": "[ 124 ] Kalichak",
                    "label": "Kalichak"
                },
                {
                    "value": "[ 125 ] Dharmapur",
                    "label": "Dharmapur"
                },
                {
                    "value": "[ 126 ] Barhnabani",
                    "label": "Barhnabani"
                },
                {
                    "value": "[ 127 ] Hemantapur",
                    "label": "Hemantapur"
                },
                {
                    "value": "[ 128 ] Masharpur",
                    "label": "Masharpur"
                },
                {
                    "value": "[ 129 ] Sitalpur",
                    "label": "Sitalpur"
                },
                {
                    "value": "[ 130 ] Islampur",
                    "label": "Islampur"
                },
                {
                    "value": "[ 131 ] Malancha",
                    "label": "Malancha"
                },
                {
                    "value": "[ 132 ] Gangadaspur",
                    "label": "Gangadaspur"
                },
                {
                    "value": "[ 133 ] Singhachak",
                    "label": "Singhachak"
                },
                {
                    "value": "[ 134 ] Narayanpur",
                    "label": "Narayanpur"
                },
                {
                    "value": "[ 135 ] Maharajpur",
                    "label": "Maharajpur"
                },
                {
                    "value": "[ 136 ] Anandapur Sundarpur",
                    "label": "Anandapur Sundarpur"
                },
                {
                    "value": "[ 137 ] Bengral Mungral",
                    "label": "Bengral Mungral"
                },
                {
                    "value": "[ 138 ] Dharmapur",
                    "label": "Dharmapur"
                },
                {
                    "value": "[ 139 ] Mandaria",
                    "label": "Mandaria"
                },
                {
                    "value": "[ 140 ] Joynagar",
                    "label": "Joynagar"
                },
                {
                    "value": "[ 141 ] Thabapur",
                    "label": "Thabapur"
                },
                {
                    "value": "[ 142 ] Ghola",
                    "label": "Ghola"
                },
                {
                    "value": "[ 143 ] Haridaspur",
                    "label": "Haridaspur"
                },
                {
                    "value": "[ 144 ] Shilarajnagar",
                    "label": "Shilarajnagar"
                },
                {
                    "value": "[ 145 ] Kushpata Gobindapur",
                    "label": "Kushpata Gobindapur"
                },
                {
                    "value": "[ 146 ] Krishnanagar (Ghatal Mu)",
                    "label": "Krishnanagar (Ghatal Mu)"
                },
                {
                    "value": "[ 147 ] Konnagar (Ghatal Mu)",
                    "label": "Konnagar (Ghatal Mu)"
                },
                {
                    "value": "[ 148 ] Sripur",
                    "label": "Sripur"
                },
                {
                    "value": "[ 149 ] Katan",
                    "label": "Katan"
                },
                {
                    "value": "[ 150 ] Patharchak Gobindapur",
                    "label": "Patharchak Gobindapur"
                },
                {
                    "value": "[ 151 ] Harisingpur",
                    "label": "Harisingpur"
                },
                {
                    "value": "[ 152 ] Pratappur",
                    "label": "Pratappur"
                },
                {
                    "value": "[ 153 ] Ratneswarbati",
                    "label": "Ratneswarbati"
                },
                {
                    "value": "[ 154 ] Gopemahalmanoharpur",
                    "label": "Gopemahalmanoharpur"
                },
                {
                    "value": "[ 155 ] Harishpur",
                    "label": "Harishpur"
                },
                {
                    "value": "[ 156 ] Shyamsundarpur",
                    "label": "Shyamsundarpur"
                }
            ]
        },
        {
            block: "[ 28 ] DASPUR-I",
            mouzaList: [
                {
                    "value": "[ 001 ] Supapursuri",
                    "label": "Supapursuri"
                },
                {
                    "value": "[ 002 ] Baluri",
                    "label": "Baluri"
                },
                {
                    "value": "[ 003 ] semana",
                    "label": "semana"
                },
                {
                    "value": "[ 004 ] Kantadarja",
                    "label": "Kantadarja"
                },
                {
                    "value": "[ 005 ] Uttar Jharia",
                    "label": "Uttar Jharia"
                },
                {
                    "value": "[ 006 ] Raikundu",
                    "label": "Raikundu"
                },
                {
                    "value": "[ 007 ] Chandipur",
                    "label": "Chandipur"
                },
                {
                    "value": "[ 008 ] Sinhaghai",
                    "label": "Sinhaghai"
                },
                {
                    "value": "[ 009 ] Dubarajpur",
                    "label": "Dubarajpur"
                },
                {
                    "value": "[ 010 ] Harirajpur",
                    "label": "Harirajpur"
                },
                {
                    "value": "[ 011 ] Dakshin Jharia",
                    "label": "Dakshin Jharia"
                },
                {
                    "value": "[ 012 ] Baramara",
                    "label": "Baramara"
                },
                {
                    "value": "[ 013 ] Hajakundu",
                    "label": "Hajakundu"
                },
                {
                    "value": "[ 014 ] Danikola",
                    "label": "Danikola"
                },
                {
                    "value": "[ 015 ] Metasara",
                    "label": "Metasara"
                },
                {
                    "value": "[ 016 ] Kismat Narajole",
                    "label": "Kismat Narajole"
                },
                {
                    "value": "[ 017 ] Nij Narajole",
                    "label": "Nij Narajole"
                },
                {
                    "value": "[ 018 ] Kalyanpur",
                    "label": "Kalyanpur"
                },
                {
                    "value": "[ 019 ] Ramdaspur",
                    "label": "Ramdaspur"
                },
                {
                    "value": "[ 020 ] Balipota",
                    "label": "Balipota"
                },
                {
                    "value": "[ 021 ] Gobrakundu",
                    "label": "Gobrakundu"
                },
                {
                    "value": "[ 022 ] Bachharakundu",
                    "label": "Bachharakundu"
                },
                {
                    "value": "[ 023 ] Samat",
                    "label": "Samat"
                },
                {
                    "value": "[ 024 ] Hossainpur",
                    "label": "Hossainpur"
                },
                {
                    "value": "[ 025 ] Rajnagar",
                    "label": "Rajnagar"
                },
                {
                    "value": "[ 026 ] Ramdebpur",
                    "label": "Ramdebpur"
                },
                {
                    "value": "[ 027 ] Jadupur",
                    "label": "Jadupur"
                },
                {
                    "value": "[ 028 ] Gokulnagar",
                    "label": "Gokulnagar"
                },
                {
                    "value": "[ 029 ] Gopalnager",
                    "label": "Gopalnager"
                },
                {
                    "value": "[ 030 ] Dihipalsha",
                    "label": "Dihipalsha"
                },
                {
                    "value": "[ 031 ] Dadpur",
                    "label": "Dadpur"
                },
                {
                    "value": "[ 032 ] Paikan Durjadhanpur",
                    "label": "Paikan Durjadhanpur"
                },
                {
                    "value": "[ 033 ] Chandpur",
                    "label": "Chandpur"
                },
                {
                    "value": "[ 034 ] Jhumjumi",
                    "label": "Jhumjumi"
                },
                {
                    "value": "[ 035 ] Belberia Gopalnagar",
                    "label": "Belberia Gopalnagar"
                },
                {
                    "value": "[ 036 ] Pakurdana",
                    "label": "Pakurdana"
                },
                {
                    "value": "[ 037 ] Anandagar",
                    "label": "Anandagar"
                },
                {
                    "value": "[ 038 ] Harirampur",
                    "label": "Harirampur"
                },
                {
                    "value": "[ 039 ] Guruli",
                    "label": "Guruli"
                },
                {
                    "value": "[ 040 ] Rupnarayanpur",
                    "label": "Rupnarayanpur"
                },
                {
                    "value": "[ 041 ] Suratpur",
                    "label": "Suratpur"
                },
                {
                    "value": "[ 042 ] Sitakundu",
                    "label": "Sitakundu"
                },
                {
                    "value": "[ 043 ] Majlispur",
                    "label": "Majlispur"
                },
                {
                    "value": "[ 044 ] Khordhabishnupur",
                    "label": "Khordhabishnupur"
                },
                {
                    "value": "[ 045 ] Dharmapur",
                    "label": "Dharmapur"
                },
                {
                    "value": "[ 046 ] Suranarayanpur",
                    "label": "Suranarayanpur"
                },
                {
                    "value": "[ 047 ] Paltaberia",
                    "label": "Paltaberia"
                },
                {
                    "value": "[ 048 ] Dihichetuya",
                    "label": "Dihichetuya"
                },
                {
                    "value": "[ 049 ] Rasulpur",
                    "label": "Rasulpur"
                },
                {
                    "value": "[ 050 ] Shyamsundarpur",
                    "label": "Shyamsundarpur"
                },
                {
                    "value": "[ 051 ] Raghunathpur",
                    "label": "Raghunathpur"
                },
                {
                    "value": "[ 052 ] Shimultala",
                    "label": "Shimultala"
                },
                {
                    "value": "[ 053 ] Sujanagar",
                    "label": "Sujanagar"
                },
                {
                    "value": "[ 054 ] Nuniyagoda",
                    "label": "Nuniyagoda"
                },
                {
                    "value": "[ 055 ] Laoda",
                    "label": "Laoda"
                },
                {
                    "value": "[ 056 ] Beliyaghata",
                    "label": "Beliyaghata"
                },
                {
                    "value": "[ 057 ] Baidyapur",
                    "label": "Baidyapur"
                },
                {
                    "value": "[ 058 ] Dihibaliharpur",
                    "label": "Dihibaliharpur"
                },
                {
                    "value": "[ 059 ] Purushattampur",
                    "label": "Purushattampur"
                },
                {
                    "value": "[ 060 ] Daspur",
                    "label": "Daspur"
                },
                {
                    "value": "[ 061 ] Mamudpur",
                    "label": "Mamudpur"
                },
                {
                    "value": "[ 062 ] Barashimulia",
                    "label": "Barashimulia"
                },
                {
                    "value": "[ 063 ] Basudebpur",
                    "label": "Basudebpur"
                },
                {
                    "value": "[ 064 ] Baikunthapur",
                    "label": "Baikunthapur"
                },
                {
                    "value": "[ 065 ] Kalmijore",
                    "label": "Kalmijore"
                },
                {
                    "value": "[ 066 ] Khatbarui",
                    "label": "Khatbarui"
                },
                {
                    "value": "[ 067 ] Radhakantapur",
                    "label": "Radhakantapur"
                },
                {
                    "value": "[ 068 ] KharRadhakantapur",
                    "label": "KharRadhakantapur"
                },
                {
                    "value": "[ 069 ] Sultannagar",
                    "label": "Sultannagar"
                },
                {
                    "value": "[ 070 ] Kunjapur",
                    "label": "Kunjapur"
                },
                {
                    "value": "[ 071 ] Samatberia",
                    "label": "Samatberia"
                },
                {
                    "value": "[ 072 ] Kalora",
                    "label": "Kalora"
                },
                {
                    "value": "[ 073 ] Kishornagar",
                    "label": "Kishornagar"
                },
                {
                    "value": "[ 074 ] Jatadharpur",
                    "label": "Jatadharpur"
                },
                {
                    "value": "[ 075 ] Barjalalpur",
                    "label": "Barjalalpur"
                },
                {
                    "value": "[ 076 ] Banshkhal",
                    "label": "Banshkhal"
                },
                {
                    "value": "[ 077 ] Basantapur",
                    "label": "Basantapur"
                },
                {
                    "value": "[ 078 ] Gobindanagar",
                    "label": "Gobindanagar"
                },
                {
                    "value": "[ 079 ] Durgapur",
                    "label": "Durgapur"
                },
                {
                    "value": "[ 087 ] Parbatipur",
                    "label": "Parbatipur"
                },
                {
                    "value": "[ 088 ] Nijampur",
                    "label": "Nijampur"
                },
                {
                    "value": "[ 089 ] Shiyadkarim",
                    "label": "Shiyadkarim"
                },
                {
                    "value": "[ 090 ] Rabidaspur",
                    "label": "Rabidaspur"
                },
                {
                    "value": "[ 091 ] Rambati",
                    "label": "Rambati"
                },
                {
                    "value": "[ 092 ] Biharichak",
                    "label": "Biharichak"
                },
                {
                    "value": "[ 093 ] Balakraut",
                    "label": "Balakraut"
                },
                {
                    "value": "[ 094 ] Bujruk Baikunthapur",
                    "label": "Bujruk Baikunthapur"
                },
                {
                    "value": "[ 095 ] Paikanlakmi",
                    "label": "Paikanlakmi"
                },
                {
                    "value": "[ 096 ] Nandanpur",
                    "label": "Nandanpur"
                },
                {
                    "value": "[ 097 ] Mirjapur",
                    "label": "Mirjapur"
                },
                {
                    "value": "[ 098 ] Tatarkha",
                    "label": "Tatarkha"
                },
                {
                    "value": "[ 099 ] Kismat Kalora",
                    "label": "Kismat Kalora"
                },
                {
                    "value": "[ 100 ] Maheshpur",
                    "label": "Maheshpur"
                },
                {
                    "value": "[ 101 ] Sekendari",
                    "label": "Sekendari"
                },
                {
                    "value": "[ 102 ] Joykrishnapur",
                    "label": "Joykrishnapur"
                },
                {
                    "value": "[ 103 ] Balitora",
                    "label": "Balitora"
                },
                {
                    "value": "[ 104 ] Sarbera",
                    "label": "Sarbera"
                },
                {
                    "value": "[ 105 ] Shoulan",
                    "label": "Shoulan"
                },
                {
                    "value": "[ 106 ] Ratnapur",
                    "label": "Ratnapur"
                },
                {
                    "value": "[ 107 ] Gangaprasad",
                    "label": "Gangaprasad"
                },
                {
                    "value": "[ 108 ] Kadilpur Fakirbazar",
                    "label": "Kadilpur Fakirbazar"
                },
                {
                    "value": "[ 109 ] Salampur",
                    "label": "Salampur"
                },
                {
                    "value": "[ 110 ] Radhanagar",
                    "label": "Radhanagar"
                },
                {
                    "value": "[ 111 ] Bramhanbasan",
                    "label": "Bramhanbasan"
                },
                {
                    "value": "[ 112 ] Tatarpur",
                    "label": "Tatarpur"
                },
                {
                    "value": "[ 113 ] Machhgera",
                    "label": "Machhgera"
                },
                {
                    "value": "[ 114 ] Jotmuri",
                    "label": "Jotmuri"
                },
                {
                    "value": "[ 115 ] Jotbani",
                    "label": "Jotbani"
                },
                {
                    "value": "[ 116 ] Nabinbasudebpur",
                    "label": "Nabinbasudebpur"
                },
                {
                    "value": "[ 117 ] Srirampur",
                    "label": "Srirampur"
                },
                {
                    "value": "[ 118 ] Damudarpur",
                    "label": "Damudarpur"
                },
                {
                    "value": "[ 119 ] Gobindapur",
                    "label": "Gobindapur"
                },
                {
                    "value": "[ 120 ] Janardanpur",
                    "label": "Janardanpur"
                },
                {
                    "value": "[ 121 ] Poushatanka",
                    "label": "Poushatanka"
                },
                {
                    "value": "[ 122 ] Kritibaspur",
                    "label": "Kritibaspur"
                },
                {
                    "value": "[ 123 ] Uttardhankhal",
                    "label": "Uttardhankhal"
                },
                {
                    "value": "[ 124 ] Dakhin Dhankhal",
                    "label": "Dakhin Dhankhal"
                },
                {
                    "value": "[ 125 ] Makrampur",
                    "label": "Makrampur"
                },
                {
                    "value": "[ 126 ] Abhirampur",
                    "label": "Abhirampur"
                },
                {
                    "value": "[ 127 ] Brindabanpur",
                    "label": "Brindabanpur"
                },
                {
                    "value": "[ 128 ] Debakul",
                    "label": "Debakul"
                },
                {
                    "value": "[ 129 ] Jagannathbati",
                    "label": "Jagannathbati"
                },
                {
                    "value": "[ 130 ] Barkashimpur",
                    "label": "Barkashimpur"
                },
                {
                    "value": "[ 131 ] Saiyadpur",
                    "label": "Saiyadpur"
                },
                {
                    "value": "[ 132 ] Gadaipur",
                    "label": "Gadaipur"
                },
                {
                    "value": "[ 133 ] Krishnanagar",
                    "label": "Krishnanagar"
                },
                {
                    "value": "[ 134 ] Anantapur",
                    "label": "Anantapur"
                },
                {
                    "value": "[ 135 ] Nabin Maheshpur",
                    "label": "Nabin Maheshpur"
                },
                {
                    "value": "[ 136 ] Manikpur",
                    "label": "Manikpur"
                },
                {
                    "value": "[ 137 ] Patla",
                    "label": "Patla"
                },
                {
                    "value": "[ 138 ] Dharmasagar",
                    "label": "Dharmasagar"
                },
                {
                    "value": "[ 139 ] Ramchandrapur",
                    "label": "Ramchandrapur"
                },
                {
                    "value": "[ 140 ] Chakprasad",
                    "label": "Chakprasad"
                },
                {
                    "value": "[ 141 ] Jyatisad",
                    "label": "Jyatisad"
                },
                {
                    "value": "[ 142 ] Paikan Buyaliya",
                    "label": "Paikan Buyaliya"
                },
                {
                    "value": "[ 143 ] Chaksundar",
                    "label": "Chaksundar"
                },
                {
                    "value": "[ 144 ] Biharichak",
                    "label": "Biharichak"
                },
                {
                    "value": "[ 145 ] Dharma",
                    "label": "Dharma"
                },
                {
                    "value": "[ 146 ] Chakboyalia",
                    "label": "Chakboyalia"
                },
                {
                    "value": "[ 147 ] Sahapur",
                    "label": "Sahapur"
                },
                {
                    "value": "[ 148 ] Tiourberya",
                    "label": "Tiourberya"
                },
                {
                    "value": "[ 149 ] Arkhana",
                    "label": "Arkhana"
                },
                {
                    "value": "[ 164 ] Uttar Gobindanagar",
                    "label": "Uttar Gobindanagar"
                },
                {
                    "value": "[ 165 ] Panchaberia",
                    "label": "Panchaberia"
                },
                {
                    "value": "[ 166 ] Jalalpur",
                    "label": "Jalalpur"
                },
                {
                    "value": "[ 170 ] Jotgouranga",
                    "label": "Jotgouranga"
                },
                {
                    "value": "[ 180 ] Kalaikundu",
                    "label": "Kalaikundu"
                },
                {
                    "value": "[ 181 ] Karunachak",
                    "label": "Karunachak"
                },
                {
                    "value": "[ 182 ] Shridharpur",
                    "label": "Shridharpur"
                },
                {
                    "value": "[ 183 ] Harekrishnapur",
                    "label": "Harekrishnapur"
                },
                {
                    "value": "[ 184 ] Baneswarpur",
                    "label": "Baneswarpur"
                },
                {
                    "value": "[ 185 ] Mahabatpur",
                    "label": "Mahabatpur"
                },
                {
                    "value": "[ 186 ] Nabinshimla",
                    "label": "Nabinshimla"
                },
                {
                    "value": "[ 192 ] Sagarpur",
                    "label": "Sagarpur"
                },
                {
                    "value": "[ 193 ] Majlishpur",
                    "label": "Majlishpur"
                },
                {
                    "value": "[ 194 ] Radhakrishnapur",
                    "label": "Radhakrishnapur"
                },
                {
                    "value": "[ 195 ] Bharatpur",
                    "label": "Bharatpur"
                },
                {
                    "value": "[ 200 ] Gopinathpur",
                    "label": "Gopinathpur"
                },
                {
                    "value": "[ 201 ] Gadighat",
                    "label": "Gadighat"
                },
                {
                    "value": "[ 202 ] Ranapur",
                    "label": "Ranapur"
                },
                {
                    "value": "[ 203 ] Kotalpur",
                    "label": "Kotalpur"
                }
            ]
        },
        {
            block: "[ 29 ] DASPUR-II",
            mouzaList: [
                {
                    "value": "[ 080 ] Goura",
                    "label": "Goura"
                },
                {
                    "value": "[ 081 ] Rampur",
                    "label": "Rampur"
                },
                {
                    "value": "[ 082 ] Lakshmanchak",
                    "label": "Lakshmanchak"
                },
                {
                    "value": "[ 083 ] Shyamchak",
                    "label": "Shyamchak"
                },
                {
                    "value": "[ 084 ] Khaschak",
                    "label": "Khaschak"
                },
                {
                    "value": "[ 085 ] Jagannathpur",
                    "label": "Jagannathpur"
                },
                {
                    "value": "[ 086 ] Sonamui",
                    "label": "Sonamui"
                },
                {
                    "value": "[ 150 ] Khukurdaha",
                    "label": "Khukurdaha"
                },
                {
                    "value": "[ 151 ] Sripur",
                    "label": "Sripur"
                },
                {
                    "value": "[ 152 ] Lakhshyakundu",
                    "label": "Lakhshyakundu"
                },
                {
                    "value": "[ 153 ] Radhaballavchak",
                    "label": "Radhaballavchak"
                },
                {
                    "value": "[ 154 ] Kuchamari",
                    "label": "Kuchamari"
                },
                {
                    "value": "[ 155 ] Nabinmanua",
                    "label": "Nabinmanua"
                },
                {
                    "value": "[ 156 ] Palashpai",
                    "label": "Palashpai"
                },
                {
                    "value": "[ 157 ] Joyramchak",
                    "label": "Joyramchak"
                },
                {
                    "value": "[ 158 ] Panchgechiya-I",
                    "label": "Panchgechiya-I"
                },
                {
                    "value": "[ 159 ] Jotekeshab",
                    "label": "Jotekeshab"
                },
                {
                    "value": "[ 160 ] Ajuria",
                    "label": "Ajuria"
                },
                {
                    "value": "[ 161 ] Gochhati",
                    "label": "Gochhati"
                },
                {
                    "value": "[ 162 ] Singhachak",
                    "label": "Singhachak"
                },
                {
                    "value": "[ 163 ] Chaksultan",
                    "label": "Chaksultan"
                },
                {
                    "value": "[ 167 ] Jotegobardhan",
                    "label": "Jotegobardhan"
                },
                {
                    "value": "[ 168 ] Jotebhagaban",
                    "label": "Jotebhagaban"
                },
                {
                    "value": "[ 169 ] Chakkishore",
                    "label": "Chakkishore"
                },
                {
                    "value": "[ 171 ] Soyla",
                    "label": "Soyla"
                },
                {
                    "value": "[ 172 ] Sonakhali",
                    "label": "Sonakhali"
                },
                {
                    "value": "[ 173 ] Tajpur",
                    "label": "Tajpur"
                },
                {
                    "value": "[ 174 ] Kelegoda",
                    "label": "Kelegoda"
                },
                {
                    "value": "[ 175 ] Juakhali",
                    "label": "Juakhali"
                },
                {
                    "value": "[ 176 ] Rana",
                    "label": "Rana"
                },
                {
                    "value": "[ 177 ] Sahachak",
                    "label": "Sahachak"
                },
                {
                    "value": "[ 178 ] Mahakalpota",
                    "label": "Mahakalpota"
                },
                {
                    "value": "[ 179 ] Kismatsoyla",
                    "label": "Kismatsoyla"
                },
                {
                    "value": "[ 187 ] Bhuta",
                    "label": "Bhuta"
                },
                {
                    "value": "[ 188 ] Ghanashyambati",
                    "label": "Ghanashyambati"
                },
                {
                    "value": "[ 189 ] Bishnupur",
                    "label": "Bishnupur"
                },
                {
                    "value": "[ 190 ] Ramkrishnapur",
                    "label": "Ramkrishnapur"
                },
                {
                    "value": "[ 191 ] Jotemaniram",
                    "label": "Jotemaniram"
                },
                {
                    "value": "[ 196 ] ISABPUR",
                    "label": "ISABPUR"
                },
                {
                    "value": "[ 197 ] RAMNAGAR",
                    "label": "RAMNAGAR"
                },
                {
                    "value": "[ 198 ] DUBRAJPUR",
                    "label": "DUBRAJPUR"
                },
                {
                    "value": "[ 199 ] GOPALPUR",
                    "label": "GOPALPUR"
                },
                {
                    "value": "[ 204 ] KALAGECHYA",
                    "label": "KALAGECHYA"
                },
                {
                    "value": "[ 205 ] KHANJAPUR",
                    "label": "KHANJAPUR"
                },
                {
                    "value": "[ 206 ] KAMALPUR",
                    "label": "KAMALPUR"
                },
                {
                    "value": "[ 207 ] SRIRAMNAGAR",
                    "label": "SRIRAMNAGAR"
                },
                {
                    "value": "[ 208 ] KAIGERYA",
                    "label": "KAIGERYA"
                },
                {
                    "value": "[ 209 ] HAZRABERH",
                    "label": "HAZRABERH"
                },
                {
                    "value": "[ 210 ] KHUDICHAK",
                    "label": "KHUDICHAK"
                },
                {
                    "value": "[ 211 ] BHAGABATIPUR",
                    "label": "BHAGABATIPUR"
                },
                {
                    "value": "[ 212 ] JOTEKANURAMGARH",
                    "label": "JOTEKANURAMGARH"
                },
                {
                    "value": "[ 213 ] RANICHAK",
                    "label": "RANICHAK"
                },
                {
                    "value": "[ 214 ] DARIAYODHYA",
                    "label": "DARIAYODHYA"
                },
                {
                    "value": "[ 215 ] UDAYCHAK",
                    "label": "UDAYCHAK"
                },
                {
                    "value": "[ 216 ] CHAIPAT",
                    "label": "CHAIPAT"
                },
                {
                    "value": "[ 217 ] BHUNIARAH",
                    "label": "BHUNIARAH"
                },
                {
                    "value": "[ 218 ] KAIJURI",
                    "label": "KAIJURI"
                },
                {
                    "value": "[ 219 ] BENAI",
                    "label": "BENAI"
                },
                {
                    "value": "[ 220 ] ARIT",
                    "label": "ARIT"
                },
                {
                    "value": "[ 221 ] NAIHATI",
                    "label": "NAIHATI"
                },
                {
                    "value": "[ 222 ] UTTARBARH",
                    "label": "UTTARBARH"
                },
                {
                    "value": "[ 223 ] MAHISGHATA",
                    "label": "MAHISGHATA"
                },
                {
                    "value": "[ 224 ] DAKSHINBARH",
                    "label": "DAKSHINBARH"
                },
                {
                    "value": "[ 225 ] ALIPUR",
                    "label": "ALIPUR"
                },
                {
                    "value": "[ 226 ] MANIKDWIPA",
                    "label": "MANIKDWIPA"
                },
                {
                    "value": "[ 227 ] FARIDPUR",
                    "label": "FARIDPUR"
                },
                {
                    "value": "[ 228 ] ADAMPUR",
                    "label": "ADAMPUR"
                },
                {
                    "value": "[ 229 ] PANCHGECHIY-II",
                    "label": "PANCHGECHIY-II"
                },
                {
                    "value": "[ 230 ] NISCHINTAPUR",
                    "label": "NISCHINTAPUR"
                },
                {
                    "value": "[ 231 ] GOURICHAK",
                    "label": "GOURICHAK"
                },
                {
                    "value": "[ 232 ] JOYRAMPUR",
                    "label": "JOYRAMPUR"
                },
                {
                    "value": "[ 233 ] SATPOTA",
                    "label": "SATPOTA"
                },
                {
                    "value": "[ 234 ] BHAGABANCHAK",
                    "label": "BHAGABANCHAK"
                },
                {
                    "value": "[ 235 ] SITAPUR",
                    "label": "SITAPUR"
                },
                {
                    "value": "[ 236 ] KASHINATHPUR",
                    "label": "KASHINATHPUR"
                },
                {
                    "value": "[ 237 ] GOMAKPOTA",
                    "label": "GOMAKPOTA"
                },
                {
                    "value": "[ 238 ] NARAYANCHAK",
                    "label": "NARAYANCHAK"
                },
                {
                    "value": "[ 239 ] DONGABHANGA",
                    "label": "DONGABHANGA"
                },
                {
                    "value": "[ 240 ] JOTEGHANASHYAM",
                    "label": "JOTEGHANASHYAM"
                },
                {
                    "value": "[ 241 ] KULTIKRI",
                    "label": "KULTIKRI"
                },
                {
                    "value": "[ 242 ] MAGURIA",
                    "label": "MAGURIA"
                },
                {
                    "value": "[ 243 ] CHAKDOGACHIA",
                    "label": "CHAKDOGACHIA"
                },
                {
                    "value": "[ 244 ] CHAKMADARIA",
                    "label": "CHAKMADARIA"
                },
                {
                    "value": "[ 245 ] DUDKOMRA",
                    "label": "DUDKOMRA"
                },
                {
                    "value": "[ 246 ] KASHIARA",
                    "label": "KASHIARA"
                },
                {
                    "value": "[ 247 ] SRIBARA",
                    "label": "SRIBARA"
                },
                {
                    "value": "[ 248 ] NONANARAYANCHAK",
                    "label": "NONANARAYANCHAK"
                }
            ]
        },
        {
            block: "[ 26 ] CHANDROKONA-I",
            mouzaList: [
                {
                    "value": "[ 001 ] Jagannathpur",
                    "label": "Jagannathpur"
                },
                {
                    "value": "[ 002 ] Dinyapore",
                    "label": "Dinyapore"
                },
                {
                    "value": "[ 003 ] Chaltabandi",
                    "label": "Chaltabandi"
                },
                {
                    "value": "[ 004 ] Balarampur",
                    "label": "Balarampur"
                },
                {
                    "value": "[ 005 ] Sola Ist Part",
                    "label": "Sola Ist Part"
                },
                {
                    "value": "[ 006 ] Bachari",
                    "label": "Bachari"
                },
                {
                    "value": "[ 007 ] Guchure",
                    "label": "Guchure"
                },
                {
                    "value": "[ 008 ] Paikmajhita",
                    "label": "Paikmajhita"
                },
                {
                    "value": "[ 009 ] Sasageria",
                    "label": "Sasageria"
                },
                {
                    "value": "[ 010 ] Thakurhati",
                    "label": "Thakurhati"
                },
                {
                    "value": "[ 011 ] Bonpur",
                    "label": "Bonpur"
                },
                {
                    "value": "[ 012 ] Kalyanchak",
                    "label": "Kalyanchak"
                },
                {
                    "value": "[ 013 ] Bahadurpur",
                    "label": "Bahadurpur"
                },
                {
                    "value": "[ 014 ] Ghola",
                    "label": "Ghola"
                },
                {
                    "value": "[ 015 ] Pandua",
                    "label": "Pandua"
                },
                {
                    "value": "[ 016 ] Ramjibanpur",
                    "label": "Ramjibanpur"
                },
                {
                    "value": "[ 017 ] Darkhola",
                    "label": "Darkhola"
                },
                {
                    "value": "[ 018 ] Rameswarpur",
                    "label": "Rameswarpur"
                },
                {
                    "value": "[ 019 ] Bachka",
                    "label": "Bachka"
                },
                {
                    "value": "[ 020 ] Khejurboni",
                    "label": "Khejurboni"
                },
                {
                    "value": "[ 021 ] Bhandaria",
                    "label": "Bhandaria"
                },
                {
                    "value": "[ 022 ] Kalapat",
                    "label": "Kalapat"
                },
                {
                    "value": "[ 023 ] Gobindapur",
                    "label": "Gobindapur"
                },
                {
                    "value": "[ 024 ] Sarbasukha",
                    "label": "Sarbasukha"
                },
                {
                    "value": "[ 025 ] Rajma",
                    "label": "Rajma"
                },
                {
                    "value": "[ 026 ] Depur",
                    "label": "Depur"
                },
                {
                    "value": "[ 027 ] Srinagar",
                    "label": "Srinagar"
                },
                {
                    "value": "[ 028 ] Doulatpur",
                    "label": "Doulatpur"
                },
                {
                    "value": "[ 029 ] Ramchak",
                    "label": "Ramchak"
                },
                {
                    "value": "[ 030 ] Lakshmipur",
                    "label": "Lakshmipur"
                },
                {
                    "value": "[ 031 ] Dhuledanga",
                    "label": "Dhuledanga"
                },
                {
                    "value": "[ 032 ] Sola-2nd part",
                    "label": "Sola-2nd part"
                },
                {
                    "value": "[ 033 ] Inda",
                    "label": "Inda"
                },
                {
                    "value": "[ 112 ] Jhalur",
                    "label": "Jhalur"
                },
                {
                    "value": "[ 113 ] Pirchak",
                    "label": "Pirchak"
                },
                {
                    "value": "[ 114 ] Jagannathpur",
                    "label": "Jagannathpur"
                },
                {
                    "value": "[ 134 ] Bamunia",
                    "label": "Bamunia"
                },
                {
                    "value": "[ 135 ] Basulia",
                    "label": "Basulia"
                },
                {
                    "value": "[ 136 ] Rankanki",
                    "label": "Rankanki"
                },
                {
                    "value": "[ 137 ] Paramanandapur",
                    "label": "Paramanandapur"
                },
                {
                    "value": "[ 138 ] Moula",
                    "label": "Moula"
                },
                {
                    "value": "[ 140 ] Degeria Ramchak",
                    "label": "Degeria Ramchak"
                },
                {
                    "value": "[ 142 ] Rejna",
                    "label": "Rejna"
                },
                {
                    "value": "[ 143 ] Sanpur",
                    "label": "Sanpur"
                },
                {
                    "value": "[ 144 ] Kochgeria Ramchak",
                    "label": "Kochgeria Ramchak"
                },
                {
                    "value": "[ 149 ] Kalapat",
                    "label": "Kalapat"
                },
                {
                    "value": "[ 150 ] Banka Sultanpur",
                    "label": "Banka Sultanpur"
                },
                {
                    "value": "[ 151 ] Manikkundu",
                    "label": "Manikkundu"
                },
                {
                    "value": "[ 152 ] Jara",
                    "label": "Jara"
                },
                {
                    "value": "[ 153 ] Mahabala",
                    "label": "Mahabala"
                },
                {
                    "value": "[ 154 ] Tegeria Dharampur",
                    "label": "Tegeria Dharampur"
                },
                {
                    "value": "[ 155 ] Ghola",
                    "label": "Ghola"
                },
                {
                    "value": "[ 156 ] Narayanpur",
                    "label": "Narayanpur"
                },
                {
                    "value": "[ 157 ] Gobindapur",
                    "label": "Gobindapur"
                },
                {
                    "value": "[ 158 ] Serba",
                    "label": "Serba"
                },
                {
                    "value": "[ 159 ] Amdan",
                    "label": "Amdan"
                },
                {
                    "value": "[ 160 ] Pathra",
                    "label": "Pathra"
                },
                {
                    "value": "[ 161 ] Karanji",
                    "label": "Karanji"
                },
                {
                    "value": "[ 162 ] Suri puskarini",
                    "label": "Suri puskarini"
                },
                {
                    "value": "[ 163 ] Sola",
                    "label": "Sola"
                },
                {
                    "value": "[ 164 ] Harinarayanpur",
                    "label": "Harinarayanpur"
                },
                {
                    "value": "[ 165 ] Tatarpur",
                    "label": "Tatarpur"
                },
                {
                    "value": "[ 166 ] Ramkrishnapur",
                    "label": "Ramkrishnapur"
                },
                {
                    "value": "[ 167 ] Panchamahar",
                    "label": "Panchamahar"
                },
                {
                    "value": "[ 168 ] Saoragiria",
                    "label": "Saoragiria"
                },
                {
                    "value": "[ 169 ] Sitasole",
                    "label": "Sitasole"
                },
                {
                    "value": "[ 170 ] Bhatahar",
                    "label": "Bhatahar"
                },
                {
                    "value": "[ 171 ] Simana",
                    "label": "Simana"
                },
                {
                    "value": "[ 172 ] Madhabpur",
                    "label": "Madhabpur"
                },
                {
                    "value": "[ 173 ] Mirerchak",
                    "label": "Mirerchak"
                },
                {
                    "value": "[ 174 ] Naranchak",
                    "label": "Naranchak"
                },
                {
                    "value": "[ 175 ] Nekarbag",
                    "label": "Nekarbag"
                },
                {
                    "value": "[ 176 ] Mangrul",
                    "label": "Mangrul"
                },
                {
                    "value": "[ 177 ] Agra",
                    "label": "Agra"
                },
                {
                    "value": "[ 178 ] Bhobla",
                    "label": "Bhobla"
                },
                {
                    "value": "[ 179 ] Beurgram",
                    "label": "Beurgram"
                },
                {
                    "value": "[ 180 ] Agar",
                    "label": "Agar"
                },
                {
                    "value": "[ 181 ] Pursuri",
                    "label": "Pursuri"
                },
                {
                    "value": "[ 182 ] Betagram",
                    "label": "Betagram"
                },
                {
                    "value": "[ 183 ] Madanchak",
                    "label": "Madanchak"
                },
                {
                    "value": "[ 184 ] Khira",
                    "label": "Khira"
                },
                {
                    "value": "[ 185 ] Shyamkhuri",
                    "label": "Shyamkhuri"
                },
                {
                    "value": "[ 186 ] Santitetul",
                    "label": "Santitetul"
                },
                {
                    "value": "[ 187 ] Amrapat",
                    "label": "Amrapat"
                },
                {
                    "value": "[ 188 ] Nilapat",
                    "label": "Nilapat"
                },
                {
                    "value": "[ 189 ] Kankabati",
                    "label": "Kankabati"
                },
                {
                    "value": "[ 190 ] Lorepur",
                    "label": "Lorepur"
                },
                {
                    "value": "[ 191 ] Hazra",
                    "label": "Hazra"
                },
                {
                    "value": "[ 192 ] Amdhere",
                    "label": "Amdhere"
                },
                {
                    "value": "[ 193 ] Goalsini",
                    "label": "Goalsini"
                },
                {
                    "value": "[ 194 ] Belgeria",
                    "label": "Belgeria"
                },
                {
                    "value": "[ 195 ] Hatpukur",
                    "label": "Hatpukur"
                },
                {
                    "value": "[ 196 ] Arjungeria",
                    "label": "Arjungeria"
                },
                {
                    "value": "[ 197 ] Kasanda",
                    "label": "Kasanda"
                },
                {
                    "value": "[ 198 ] Andheria",
                    "label": "Andheria"
                },
                {
                    "value": "[ 199 ] Goaldanga",
                    "label": "Goaldanga"
                },
                {
                    "value": "[ 200 ] Nisanchak",
                    "label": "Nisanchak"
                },
                {
                    "value": "[ 201 ] Nichna",
                    "label": "Nichna"
                },
                {
                    "value": "[ 202 ] Nonadanga",
                    "label": "Nonadanga"
                },
                {
                    "value": "[ 203 ] Mamudpur",
                    "label": "Mamudpur"
                },
                {
                    "value": "[ 204 ] Beladanda",
                    "label": "Beladanda"
                },
                {
                    "value": "[ 205 ] Jamira",
                    "label": "Jamira"
                },
                {
                    "value": "[ 206 ] Subudhichak",
                    "label": "Subudhichak"
                },
                {
                    "value": "[ 207 ] Birbhanpur",
                    "label": "Birbhanpur"
                },
                {
                    "value": "[ 208 ] Bara",
                    "label": "Bara"
                },
                {
                    "value": "[ 209 ] Hematpur",
                    "label": "Hematpur"
                },
                {
                    "value": "[ 210 ] Kashkuli",
                    "label": "Kashkuli"
                },
                {
                    "value": "[ 211 ] Bhabanipur",
                    "label": "Bhabanipur"
                },
                {
                    "value": "[ 213 ] Kashiganj",
                    "label": "Kashiganj"
                },
                {
                    "value": "[ 214 ] Khirpai",
                    "label": "Khirpai"
                },
                {
                    "value": "[ 215 ] Bamaria",
                    "label": "Bamaria"
                },
                {
                    "value": "[ 216 ] Marh",
                    "label": "Marh"
                },
                {
                    "value": "[ 217 ] Ramaichak",
                    "label": "Ramaichak"
                },
                {
                    "value": "[ 218 ] Maheshpur",
                    "label": "Maheshpur"
                },
                {
                    "value": "[ 219 ] Gopalpur",
                    "label": "Gopalpur"
                },
                {
                    "value": "[ 220 ] Dharampur",
                    "label": "Dharampur"
                },
                {
                    "value": "[ 221 ] Gangadaspur",
                    "label": "Gangadaspur"
                },
                {
                    "value": "[ 222 ] Parulia",
                    "label": "Parulia"
                },
                {
                    "value": "[ 223 ] Saljhati",
                    "label": "Saljhati"
                },
                {
                    "value": "[ 224 ] Mohanpur",
                    "label": "Mohanpur"
                },
                {
                    "value": "[ 225 ] Berabera",
                    "label": "Berabera"
                },
                {
                    "value": "[ 226 ] Hijli",
                    "label": "Hijli"
                },
                {
                    "value": "[ 227 ] Mathurapur",
                    "label": "Mathurapur"
                },
                {
                    "value": "[ 228 ] Nirvoypur",
                    "label": "Nirvoypur"
                },
                {
                    "value": "[ 261 ] Doya",
                    "label": "Doya"
                },
                {
                    "value": "[ 262 ] Chandur",
                    "label": "Chandur"
                },
                {
                    "value": "[ 264 ] Nishchintipur",
                    "label": "Nishchintipur"
                },
                {
                    "value": "[ 265 ] Kharakpur",
                    "label": "Kharakpur"
                },
                {
                    "value": "[ 266 ] Gancha",
                    "label": "Gancha"
                },
                {
                    "value": "[ 267 ] Paikpara",
                    "label": "Paikpara"
                },
                {
                    "value": "[ 269 ] Kelemi",
                    "label": "Kelemi"
                },
                {
                    "value": "[ 272 ] Khamarberia",
                    "label": "Khamarberia"
                },
                {
                    "value": "[ 273 ] Pandua",
                    "label": "Pandua"
                },
                {
                    "value": "[ 274 ] Khanpur",
                    "label": "Khanpur"
                },
                {
                    "value": "[ 275 ] Hiradharpur",
                    "label": "Hiradharpur"
                },
                {
                    "value": "[ 276 ] Fulchak",
                    "label": "Fulchak"
                },
                {
                    "value": "[ 277 ] Kamargeria",
                    "label": "Kamargeria"
                },
                {
                    "value": "[ 278 ] Ekbalpur",
                    "label": "Ekbalpur"
                },
                {
                    "value": "[ 279 ] Dingal",
                    "label": "Dingal"
                },
                {
                    "value": "[ 280 ] Balinagar",
                    "label": "Balinagar"
                },
                {
                    "value": "[ 281 ] Patlapur",
                    "label": "Patlapur"
                },
                {
                    "value": "[ 282 ] Gopalpur",
                    "label": "Gopalpur"
                },
                {
                    "value": "[ 283 ] Jadabpur",
                    "label": "Jadabpur"
                },
                {
                    "value": "[ 284 ] Kuldaha",
                    "label": "Kuldaha"
                },
                {
                    "value": "[ 285 ] Sitarampur",
                    "label": "Sitarampur"
                },
                {
                    "value": "[ 286 ] Manaharpur",
                    "label": "Manaharpur"
                },
                {
                    "value": "[ 287 ] gamariya",
                    "label": "gamariya"
                }
            ]
        },
        {
            block: "[ 25 ] CHANDROKONA-II",
            mouzaList: [
                {
                    "value": "[ 034 ] Lahirganj",
                    "label": "Lahirganj"
                },
                {
                    "value": "[ 035 ] Krishnapur",
                    "label": "Krishnapur"
                },
                {
                    "value": "[ 036 ] Sauberiya",
                    "label": "Sauberiya"
                },
                {
                    "value": "[ 037 ] Eidpur",
                    "label": "Eidpur"
                },
                {
                    "value": "[ 038 ] Paruliya",
                    "label": "Paruliya"
                },
                {
                    "value": "[ 039 ] Pachami",
                    "label": "Pachami"
                },
                {
                    "value": "[ 040 ] Nityanandapur",
                    "label": "Nityanandapur"
                },
                {
                    "value": "[ 041 ] Guadanga",
                    "label": "Guadanga"
                },
                {
                    "value": "[ 042 ] Chasibar",
                    "label": "Chasibar"
                },
                {
                    "value": "[ 043 ] Chaitnyapur",
                    "label": "Chaitnyapur"
                },
                {
                    "value": "[ 044 ] Nischintapur",
                    "label": "Nischintapur"
                },
                {
                    "value": "[ 045 ] Ishnagar",
                    "label": "Ishnagar"
                },
                {
                    "value": "[ 046 ] Kunwarpur",
                    "label": "Kunwarpur"
                },
                {
                    "value": "[ 047 ] Deulbere",
                    "label": "Deulbere"
                },
                {
                    "value": "[ 048 ] Maheshpur",
                    "label": "Maheshpur"
                },
                {
                    "value": "[ 049 ] Murakata",
                    "label": "Murakata"
                },
                {
                    "value": "[ 050 ] Khandanga",
                    "label": "Khandanga"
                },
                {
                    "value": "[ 051 ] Hurhuria",
                    "label": "Hurhuria"
                },
                {
                    "value": "[ 052 ] Gargarighati",
                    "label": "Gargarighati"
                },
                {
                    "value": "[ 053 ] Bankati",
                    "label": "Bankati"
                },
                {
                    "value": "[ 054 ] Khirati",
                    "label": "Khirati"
                },
                {
                    "value": "[ 055 ] Bhairabpur",
                    "label": "Bhairabpur"
                },
                {
                    "value": "[ 056 ] Metala",
                    "label": "Metala"
                },
                {
                    "value": "[ 057 ] Kamarkhali",
                    "label": "Kamarkhali"
                },
                {
                    "value": "[ 058 ] Rasiari",
                    "label": "Rasiari"
                },
                {
                    "value": "[ 059 ] Dhanyaghori",
                    "label": "Dhanyaghori"
                },
                {
                    "value": "[ 060 ] Tilara",
                    "label": "Tilara"
                },
                {
                    "value": "[ 061 ] Parahari",
                    "label": "Parahari"
                },
                {
                    "value": "[ 062 ] Jadav Nagar",
                    "label": "Jadav Nagar"
                },
                {
                    "value": "[ 063 ] Gosaibandh",
                    "label": "Gosaibandh"
                },
                {
                    "value": "[ 064 ] Homgere",
                    "label": "Homgere"
                },
                {
                    "value": "[ 065 ] Nilgunj",
                    "label": "Nilgunj"
                },
                {
                    "value": "[ 066 ] Sitanagar",
                    "label": "Sitanagar"
                },
                {
                    "value": "[ 067 ] Chhatraganj",
                    "label": "Chhatraganj"
                },
                {
                    "value": "[ 068 ] Basanchhora",
                    "label": "Basanchhora"
                },
                {
                    "value": "[ 069 ] Panchhora",
                    "label": "Panchhora"
                },
                {
                    "value": "[ 070 ] Barbila",
                    "label": "Barbila"
                },
                {
                    "value": "[ 071 ] Barnia",
                    "label": "Barnia"
                },
                {
                    "value": "[ 072 ] Ghoskira",
                    "label": "Ghoskira"
                },
                {
                    "value": "[ 073 ] Shirsa",
                    "label": "Shirsa"
                },
                {
                    "value": "[ 074 ] Dharmapota",
                    "label": "Dharmapota"
                },
                {
                    "value": "[ 075 ] Khursi",
                    "label": "Khursi"
                },
                {
                    "value": "[ 076 ] Kalla",
                    "label": "Kalla"
                },
                {
                    "value": "[ 077 ] Karasia",
                    "label": "Karasia"
                },
                {
                    "value": "[ 078 ] Rampur",
                    "label": "Rampur"
                },
                {
                    "value": "[ 079 ] Peardanga",
                    "label": "Peardanga"
                },
                {
                    "value": "[ 080 ] Bhalukkundu",
                    "label": "Bhalukkundu"
                },
                {
                    "value": "[ 081 ] Sanchorpota",
                    "label": "Sanchorpota"
                },
                {
                    "value": "[ 082 ] Shiromonipur",
                    "label": "Shiromonipur"
                },
                {
                    "value": "[ 083 ] Prasadpur",
                    "label": "Prasadpur"
                },
                {
                    "value": "[ 084 ] Bachka",
                    "label": "Bachka"
                },
                {
                    "value": "[ 085 ] Baidyanathpur",
                    "label": "Baidyanathpur"
                },
                {
                    "value": "[ 086 ] Bhagabanbati",
                    "label": "Bhagabanbati"
                },
                {
                    "value": "[ 087 ] Raghunathpur",
                    "label": "Raghunathpur"
                },
                {
                    "value": "[ 088 ] Ayodhya",
                    "label": "Ayodhya"
                },
                {
                    "value": "[ 089 ] Dhamkuria",
                    "label": "Dhamkuria"
                },
                {
                    "value": "[ 090 ] Ramgarh",
                    "label": "Ramgarh"
                },
                {
                    "value": "[ 091 ] Lalgarh",
                    "label": "Lalgarh"
                },
                {
                    "value": "[ 092 ] Chancharberh",
                    "label": "Chancharberh"
                },
                {
                    "value": "[ 093 ] Ranigunj",
                    "label": "Ranigunj"
                },
                {
                    "value": "[ 094 ] Madabpur",
                    "label": "Madabpur"
                },
                {
                    "value": "[ 095 ] Dhurabila",
                    "label": "Dhurabila"
                },
                {
                    "value": "[ 096 ] Dharampur",
                    "label": "Dharampur"
                },
                {
                    "value": "[ 097 ] Lalitagunj",
                    "label": "Lalitagunj"
                },
                {
                    "value": "[ 098 ] Basantapur",
                    "label": "Basantapur"
                },
                {
                    "value": "[ 099 ] Radhaballavpur",
                    "label": "Radhaballavpur"
                },
                {
                    "value": "[ 100 ] Malleswarpur",
                    "label": "Malleswarpur"
                },
                {
                    "value": "[ 101 ] Bhilaibani",
                    "label": "Bhilaibani"
                },
                {
                    "value": "[ 102 ] Gopsai",
                    "label": "Gopsai"
                },
                {
                    "value": "[ 103 ] Chandrakona",
                    "label": "Chandrakona"
                },
                {
                    "value": "[ 104 ] Banshdaha",
                    "label": "Banshdaha"
                },
                {
                    "value": "[ 105 ] Jirat Mundamal",
                    "label": "Jirat Mundamal"
                },
                {
                    "value": "[ 106 ] Bona",
                    "label": "Bona"
                },
                {
                    "value": "[ 107 ] Ramgunj",
                    "label": "Ramgunj"
                },
                {
                    "value": "[ 108 ] Kamargunj",
                    "label": "Kamargunj"
                },
                {
                    "value": "[ 109 ] Jayantipur",
                    "label": "Jayantipur"
                },
                {
                    "value": "[ 110 ] Gopinathpur",
                    "label": "Gopinathpur"
                },
                {
                    "value": "[ 111 ] Arjipichak",
                    "label": "Arjipichak"
                },
                {
                    "value": "[ 115 ] Penkala",
                    "label": "Penkala"
                },
                {
                    "value": "[ 116 ] Dalimabari",
                    "label": "Dalimabari"
                },
                {
                    "value": "[ 117 ] Harisinghpur",
                    "label": "Harisinghpur"
                },
                {
                    "value": "[ 118 ] Tokahoda",
                    "label": "Tokahoda"
                },
                {
                    "value": "[ 119 ] Baikunthapur",
                    "label": "Baikunthapur"
                },
                {
                    "value": "[ 120 ] Narua",
                    "label": "Narua"
                },
                {
                    "value": "[ 121 ] Jadupur",
                    "label": "Jadupur"
                },
                {
                    "value": "[ 122 ] Chhoto Akna",
                    "label": "Chhoto Akna"
                },
                {
                    "value": "[ 123 ] Boro Akna",
                    "label": "Boro Akna"
                },
                {
                    "value": "[ 124 ] Krishnakundu",
                    "label": "Krishnakundu"
                },
                {
                    "value": "[ 125 ] Belgeriya",
                    "label": "Belgeriya"
                },
                {
                    "value": "[ 126 ] Akatkola",
                    "label": "Akatkola"
                },
                {
                    "value": "[ 127 ] Gangcha",
                    "label": "Gangcha"
                },
                {
                    "value": "[ 128 ] Shripur",
                    "label": "Shripur"
                },
                {
                    "value": "[ 129 ] Radhanagar",
                    "label": "Radhanagar"
                },
                {
                    "value": "[ 130 ] Bolghata",
                    "label": "Bolghata"
                },
                {
                    "value": "[ 131 ] Shimla",
                    "label": "Shimla"
                },
                {
                    "value": "[ 132 ] Dhaikhanda",
                    "label": "Dhaikhanda"
                },
                {
                    "value": "[ 133 ] Barasat",
                    "label": "Barasat"
                },
                {
                    "value": "[ 139 ] Langalbhanga",
                    "label": "Langalbhanga"
                },
                {
                    "value": "[ 141 ] Raska",
                    "label": "Raska"
                },
                {
                    "value": "[ 145 ] Muide",
                    "label": "Muide"
                },
                {
                    "value": "[ 146 ] Jamdan",
                    "label": "Jamdan"
                },
                {
                    "value": "[ 147 ] Gopalpur",
                    "label": "Gopalpur"
                },
                {
                    "value": "[ 148 ] Kalakari",
                    "label": "Kalakari"
                },
                {
                    "value": "[ 212 ] Bagpota",
                    "label": "Bagpota"
                },
                {
                    "value": "[ 229 ] Kadamtala",
                    "label": "Kadamtala"
                },
                {
                    "value": "[ 230 ] Tenpur",
                    "label": "Tenpur"
                },
                {
                    "value": "[ 231 ] Kharusa",
                    "label": "Kharusa"
                },
                {
                    "value": "[ 232 ] Shrirampur Atghora",
                    "label": "Shrirampur Atghora"
                },
                {
                    "value": "[ 233 ] Atghora",
                    "label": "Atghora"
                },
                {
                    "value": "[ 234 ] Kechkapur",
                    "label": "Kechkapur"
                },
                {
                    "value": "[ 235 ] Jhankra",
                    "label": "Jhankra"
                },
                {
                    "value": "[ 236 ] Madanmohanpur",
                    "label": "Madanmohanpur"
                },
                {
                    "value": "[ 237 ] Manahorgunj",
                    "label": "Manahorgunj"
                },
                {
                    "value": "[ 238 ] Shyamganj",
                    "label": "Shyamganj"
                },
                {
                    "value": "[ 239 ] Bala",
                    "label": "Bala"
                },
                {
                    "value": "[ 240 ] Radhanagar",
                    "label": "Radhanagar"
                },
                {
                    "value": "[ 241 ] Pardeshipara",
                    "label": "Pardeshipara"
                },
                {
                    "value": "[ 242 ] Kuanpur",
                    "label": "Kuanpur"
                },
                {
                    "value": "[ 243 ] Badra",
                    "label": "Badra"
                },
                {
                    "value": "[ 244 ] Tukuria",
                    "label": "Tukuria"
                },
                {
                    "value": "[ 245 ] Dhanyajhati",
                    "label": "Dhanyajhati"
                },
                {
                    "value": "[ 246 ] Raila",
                    "label": "Raila"
                },
                {
                    "value": "[ 247 ] Khalakpur",
                    "label": "Khalakpur"
                },
                {
                    "value": "[ 248 ] Pinglas",
                    "label": "Pinglas"
                },
                {
                    "value": "[ 249 ] Agrapara",
                    "label": "Agrapara"
                },
                {
                    "value": "[ 250 ] Padua",
                    "label": "Padua"
                },
                {
                    "value": "[ 251 ] Saora",
                    "label": "Saora"
                },
                {
                    "value": "[ 252 ] Mamudpur",
                    "label": "Mamudpur"
                },
                {
                    "value": "[ 253 ] Jhakra Shirsa",
                    "label": "Jhakra Shirsa"
                },
                {
                    "value": "[ 254 ] Gangarampur",
                    "label": "Gangarampur"
                },
                {
                    "value": "[ 255 ] Rajgunj",
                    "label": "Rajgunj"
                },
                {
                    "value": "[ 256 ] Bhagirathpur",
                    "label": "Bhagirathpur"
                },
                {
                    "value": "[ 257 ] Ghanarampur",
                    "label": "Ghanarampur"
                },
                {
                    "value": "[ 258 ] Bandipur",
                    "label": "Bandipur"
                },
                {
                    "value": "[ 259 ] Brahmankola",
                    "label": "Brahmankola"
                },
                {
                    "value": "[ 260 ] Bhotakhali",
                    "label": "Bhotakhali"
                },
                {
                    "value": "[ 263 ] Dhanyagachhi",
                    "label": "Dhanyagachhi"
                },
                {
                    "value": "[ 268 ] Kaigeria",
                    "label": "Kaigeria"
                },
                {
                    "value": "[ 270 ] Shirsa",
                    "label": "Shirsa"
                },
                {
                    "value": "[ 271 ] Pirijpur",
                    "label": "Pirijpur"
                }
            ]
        }
    ]
}